var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicrosoftSharepoint = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2481 0C15.1805 0 18.3729 3.18727 18.3729 7.12658C18.3729 11.0599 15.1865 14.2532 11.2481 14.2532C7.31576 14.2532 4.12332 11.0659 4.12332 7.12658C4.12332 3.18727 7.31576 0 11.2481 0Z",
    fill: "#036C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9015 7.30565C21.267 7.30565 24 10.0333 24 13.4056C24 16.7719 21.273 19.5056 17.9015 19.5056C14.5361 19.5056 11.8031 16.7779 11.8031 13.4056C11.809 10.0333 14.5361 7.30565 17.9015 7.30565Z",
    fill: "#1A9BA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.994 14.2472C14.6852 14.2472 16.8692 16.4317 16.8692 19.1236C16.8692 21.8155 14.6852 24 11.994 24C9.30283 24 7.11885 21.8155 7.11885 19.1236C7.12481 16.4317 9.30283 14.2472 11.994 14.2472Z",
    fill: "#37C6D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3819 5.78364H11.827C11.8747 5.85526 11.9105 5.93285 11.9284 6.01641H12.0716C12.4833 6.02238 12.8175 6.3626 12.8056 6.77443V10.0453C12.8891 9.91395 12.9846 9.78861 13.0801 9.66327V6.52972C13.092 6.13579 12.7757 5.80154 12.3819 5.78364Z",
    fill: "#03686C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.086 9.66924C12.9906 9.79458 12.901 9.91992 12.8115 10.0512V14.3188C12.901 14.3367 12.9965 14.3546 13.086 14.3725V9.66924Z",
    fill: "#19969B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8115 14.3188L12.8115 17.7031V17.709C12.8115 17.7568 12.8056 17.7986 12.7996 17.8463C12.9726 17.524 13.086 17.0286 13.086 16.5034V14.3725C12.9965 14.3487 12.901 14.3308 12.8115 14.3188Z",
    fill: "#35BFC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60815 16.9331H7.60219C7.40527 17.333 7.25609 17.7627 7.17255 18.2223H7.17852C7.26206 17.7687 7.40527 17.333 7.60815 16.9331Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13675 19.4399H7.13078C7.13675 19.5474 7.14271 19.6548 7.16658 19.7622C7.14868 19.6548 7.14271 19.5474 7.13675 19.4399Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 18.8311C11.9881 18.861 11.9284 18.8849 11.8687 18.9028C11.7076 19.2251 11.3734 19.4399 10.9915 19.4399C10.9796 19.4399 10.9677 19.4399 10.9557 19.4399H7.14271C7.14868 19.5474 7.16062 19.6548 7.17255 19.7622C7.17255 19.7742 7.17852 19.7802 7.17852 19.7921H11.0035C11.0214 19.7921 11.0393 19.7921 11.0512 19.7921C11.5763 19.7921 12.0119 19.3803 12.0418 18.849C12.0358 18.8431 12.0418 18.8371 12.0418 18.8311Z",
    fill: "#33B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7996 17.8403C12.7936 17.8463 12.7936 17.8582 12.7877 17.8642V17.8941C12.7936 17.8761 12.7936 17.8582 12.7996 17.8403Z",
    fill: "#33B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0776 6.01641H11.9344C11.9523 6.0761 11.9582 6.13579 11.9582 6.20144V6.32678H12.0418H12.0477C12.4595 6.33275 12.7877 6.667 12.7877 7.07884V10.087C12.7936 10.0751 12.8056 10.0632 12.8115 10.0512L12.8115 6.7804C12.8175 6.3626 12.4893 6.02238 12.0776 6.01641Z",
    fill: "#036165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8115 10.0512C12.8056 10.0632 12.7936 10.0751 12.7877 10.087V14.3129C12.7936 14.3129 12.8056 14.3129 12.8115 14.3188V10.0512Z",
    fill: "#178C91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7877 14.3129V17.8642C12.7936 17.8582 12.7936 17.8463 12.7996 17.8403C12.8056 17.7986 12.8115 17.7508 12.8115 17.7031L12.8115 14.3129C12.8056 14.3129 12.7936 14.3129 12.7877 14.3129Z",
    fill: "#32B3BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7877 17.8941C12.734 18.103 12.5848 18.2761 12.3938 18.3715C12.3759 18.4491 12.3401 18.5208 12.2984 18.5864C12.5788 18.485 12.7817 18.2164 12.7877 17.8941Z",
    fill: "#33B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7877 17.8642C12.6803 18.0552 12.5549 18.1806 12.4177 18.2164C12.4177 18.2701 12.4058 18.3238 12.3938 18.3775C12.5848 18.282 12.734 18.1089 12.7877 17.9V17.8941V17.8642Z",
    fill: "#30ACB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 6.32678H11.9523V6.67297C12.3521 6.6849 12.6743 7.01915 12.6743 7.41905V10.2601C12.7101 10.2004 12.7459 10.1408 12.7817 10.087V7.07884C12.7877 6.667 12.4535 6.33275 12.0418 6.32678Z",
    fill: "#035B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7877 10.087C12.7519 10.1467 12.7161 10.2004 12.6803 10.2601V14.295C12.7161 14.3009 12.7519 14.3069 12.7877 14.3129V10.087Z",
    fill: "#168388"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6803 14.295V16.4795C12.6743 16.8854 12.5848 17.2793 12.4177 17.6374V18.1806C12.4177 18.1925 12.4177 18.1985 12.4177 18.2104C12.5549 18.1746 12.6803 18.0492 12.7877 17.8582V14.3069C12.7519 14.3069 12.7161 14.3009 12.6803 14.295Z",
    fill: "#2EA7AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2004 5.44342H4.33217C4.31427 5.51505 4.29637 5.58667 4.28444 5.65829H11.1586C11.3138 5.65829 11.457 5.70604 11.5763 5.78364L11.827 5.78364C11.6897 5.5807 11.463 5.44939 11.2004 5.44342Z",
    fill: "#036B6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 5.78364L11.5763 5.78364C11.6658 5.84332 11.7434 5.92092 11.7971 6.01641H11.9284C11.9105 5.93285 11.8747 5.85526 11.827 5.78364Z",
    fill: "#03676B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9284 6.01641H11.7971C11.8508 6.10594 11.8866 6.20144 11.8986 6.30888C11.8986 6.31485 11.9045 6.32082 11.9045 6.32678H11.9523L11.9523 6.20144C11.9523 6.13579 11.9463 6.0761 11.9284 6.01641Z",
    fill: "#036164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6992 14.2293C10.8782 14.2412 11.0572 14.2472 11.2422 14.2472C11.2481 14.2472 11.2481 14.2472 11.2541 14.2472C11.3734 14.2472 11.4868 14.2472 11.6002 14.2412C11.636 14.2412 11.6718 14.2353 11.7076 14.2353C11.7315 14.2353 11.7494 14.2293 11.7732 14.2293C11.6002 14.2412 11.4272 14.2472 11.2541 14.2472C11.087 14.2472 10.9199 14.2412 10.7529 14.2293C10.729 14.2293 10.7171 14.2293 10.6992 14.2293Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2174C11.7315 14.2293 11.636 14.2353 11.5405 14.2353C11.4451 14.2412 11.3496 14.2412 11.2541 14.2412C11.2481 14.2412 11.2362 14.2412 11.2302 14.2412C11.2064 14.2412 11.1825 14.2412 11.1527 14.2412C11.0154 14.2412 10.8841 14.2353 10.7469 14.2293C10.914 14.2412 11.0811 14.2472 11.2481 14.2472C11.4212 14.2472 11.5942 14.2412 11.7673 14.2293C11.7852 14.2293 11.809 14.2233 11.827 14.2174Z",
    fill: "#036B6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5346 14.2412C11.4451 14.2412 11.3615 14.2412 11.272 14.2412C11.2541 14.2412 11.2422 14.2412 11.2243 14.2412C11.2302 14.2412 11.2422 14.2412 11.2481 14.2412C11.3436 14.2412 11.4391 14.2412 11.5346 14.2412Z",
    fill: "#036468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 6.32678H11.9045C11.9344 6.41035 11.9523 6.49988 11.9523 6.59537L11.9523 6.67297V6.32678Z",
    fill: "#035A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17852 18.2223H7.17255C7.11885 18.5148 7.08901 18.8132 7.08901 19.1176V19.4399H7.12481C7.11885 19.3564 7.11885 19.2728 7.11885 19.1833C7.11885 19.1594 7.11885 19.1415 7.11885 19.1176H7.10691C7.10691 19.052 7.10691 18.9923 7.11288 18.9266H7.10691C7.11288 18.8311 7.11885 18.7297 7.12481 18.6342C7.13675 18.5327 7.14868 18.4312 7.16658 18.3298C7.16658 18.294 7.17255 18.2581 7.17852 18.2223Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60815 16.9331C7.40527 17.333 7.26206 17.7687 7.17255 18.2223H7.17852C7.26206 17.7687 7.41124 17.333 7.60815 16.9331Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12481 19.1176C7.12481 19.1415 7.12481 19.1594 7.12481 19.1833C7.12481 19.2668 7.12481 19.3564 7.13078 19.4399H7.13675C7.13078 19.3325 7.12481 19.231 7.12481 19.1236C7.12481 19.1176 7.12481 19.1176 7.12481 19.1176Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 18.9028C11.8031 18.9207 11.7374 18.9266 11.6718 18.9266H11.5704C11.4092 19.046 11.2064 19.1176 10.9915 19.1176C10.9856 19.1176 10.9856 19.1176 10.9796 19.1176H7.12481V19.1236C7.12481 19.231 7.13078 19.3325 7.13675 19.4399L10.9498 19.4399C10.9617 19.4399 10.9736 19.4399 10.9856 19.4399C11.3675 19.4399 11.7016 19.2251 11.8628 18.9028Z",
    fill: "#2DA1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12481 18.9266L7.10691 18.9266C7.10691 18.9863 7.10094 19.052 7.10094 19.1176L7.11885 19.1176C7.12481 19.052 7.12481 18.9923 7.12481 18.9266Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13078 18.9266C7.12481 18.9863 7.12481 19.052 7.12481 19.1176C7.12481 19.052 7.12481 18.9923 7.13078 18.9266Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5704 18.9266H7.12481C7.12481 18.9863 7.11885 19.052 7.11885 19.1176L10.9736 19.1176C10.9796 19.1176 10.9796 19.1176 10.9856 19.1176C11.2123 19.1176 11.4092 19.046 11.5704 18.9266Z",
    fill: "#278E95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16062 18.3298C7.14271 18.4312 7.13078 18.5327 7.11885 18.6342C7.13675 18.5327 7.14868 18.4312 7.16062 18.3298Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 6.67297V6.71475C12.1074 6.81622 12.2208 6.93559 12.2208 7.07287V7.45486C12.3401 7.58617 12.4177 7.76523 12.4177 7.95623V10.7436C12.4953 10.5765 12.5848 10.4153 12.6803 10.2601V7.41905C12.6803 7.01318 12.358 6.6849 11.9523 6.67297Z",
    fill: "#035658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6803 10.2601C12.5848 10.4153 12.5012 10.5765 12.4177 10.7436V14.2651C12.5072 14.2711 12.5907 14.283 12.6803 14.295V10.2601Z",
    fill: "#147B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4177 14.2651V17.6434C12.5848 17.2793 12.6743 16.8854 12.6803 16.4855V14.3009C12.5907 14.283 12.5072 14.2711 12.4177 14.2651Z",
    fill: "#2B9DA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 6.71475V6.8759C12.0895 7.01318 12.179 7.20418 12.179 7.41905C12.1909 7.43099 12.2088 7.44889 12.2208 7.46083V7.07884C12.2208 6.93559 12.1074 6.81622 11.9523 6.71475Z",
    fill: "#024649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12332 7.17433C4.12332 10.5765 6.58777 13.5787 10.0547 14.1517H10.0607C10.2755 14.1875 10.4903 14.2114 10.7051 14.2293C10.3173 14.1995 9.93535 14.1398 9.55346 14.0443C9.2909 13.9786 9.03431 13.901 8.78369 13.8115C6.29538 12.9043 4.54699 10.6779 4.19493 8.10545C4.14719 7.80104 4.12332 7.49067 4.12332 7.17433Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77772 13.8115C9.02834 13.901 9.28493 13.9846 9.54749 14.0443C9.92342 14.1398 10.3113 14.1995 10.6992 14.2293C10.7171 14.2293 10.729 14.2293 10.7469 14.2353C10.1979 14.1995 9.66683 14.098 9.16559 13.9428C9.11785 13.9249 9.06415 13.913 9.01641 13.8951C8.93287 13.8652 8.8553 13.8354 8.77772 13.8115Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2174C11.7494 14.2293 11.6718 14.2353 11.5883 14.2353C11.5704 14.2353 11.5525 14.2353 11.5346 14.2353C11.636 14.2353 11.7315 14.2293 11.827 14.2174ZM9.15962 13.9368C9.66683 14.092 10.1979 14.1935 10.7409 14.2293C10.8782 14.2353 11.0094 14.2412 11.1467 14.2412C11.1706 14.2412 11.1944 14.2412 11.2243 14.2412C11.1885 14.2412 11.1527 14.2412 11.1169 14.2412C10.6574 14.2353 10.1979 14.1875 9.75037 14.092C9.55346 14.0502 9.35654 13.9965 9.15962 13.9368Z",
    fill: "#025659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.821 14.2174H11.815C11.8031 14.2174 11.7971 14.2174 11.7852 14.2233C11.7195 14.2293 11.6539 14.2353 11.5883 14.2412C11.6658 14.2353 11.7494 14.2293 11.821 14.2174Z",
    fill: "#025054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5883 14.2353C11.4809 14.2412 11.3734 14.2412 11.2601 14.2412C11.2541 14.2412 11.2481 14.2412 11.2422 14.2412C11.2302 14.2412 11.2243 14.2412 11.2123 14.2412C11.1885 14.2412 11.1586 14.2412 11.1348 14.2412H11.1288C11.1646 14.2412 11.2004 14.2412 11.2362 14.2412C11.2541 14.2412 11.266 14.2412 11.2839 14.2412C11.3734 14.2412 11.463 14.2412 11.5465 14.2412C11.5525 14.2412 11.5704 14.2412 11.5883 14.2353Z",
    fill: "#025054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7911 14.2233C11.6181 14.2412 11.4391 14.2412 11.2601 14.2412C11.3734 14.2412 11.4809 14.2412 11.5883 14.2353C11.6539 14.2353 11.7255 14.2293 11.7911 14.2233Z",
    fill: "#024C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 14.2174C11.8031 14.2174 11.7971 14.2174 11.7852 14.2233C11.7971 14.2233 11.809 14.2174 11.815 14.2174Z",
    fill: "#013537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2541 14.2412C11.2422 14.2412 11.2362 14.2412 11.2362 14.2412C11.2422 14.2412 11.2481 14.2412 11.2541 14.2412Z",
    fill: "#023A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 14.2174C11.642 14.2412 11.463 14.2412 11.272 14.2412C11.266 14.2412 11.2601 14.2412 11.2541 14.2412C11.4331 14.2412 11.6121 14.2412 11.7852 14.2233C11.7971 14.2233 11.8031 14.2174 11.815 14.2174Z",
    fill: "#013335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2174C11.821 14.2174 11.821 14.2174 11.815 14.2174H11.827Z",
    fill: "#024346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2174C11.821 14.2174 11.815 14.2174 11.809 14.2174H11.815C11.821 14.2174 11.821 14.2174 11.827 14.2174Z",
    fill: "#012F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.809 14.2174C11.636 14.2412 11.451 14.2412 11.272 14.2412C11.457 14.2412 11.642 14.2412 11.809 14.2174Z",
    fill: "#013032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 6.8759V7.10271C11.9582 7.13852 11.9642 7.17434 11.9702 7.21015C11.9821 7.23999 11.9881 7.26983 12 7.29968C12.0656 7.32952 12.1253 7.3713 12.179 7.42502C12.179 7.20418 12.0955 7.01318 11.9523 6.8759Z",
    fill: "#024042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.10271C11.9582 7.13852 11.9642 7.17433 11.9702 7.20418C11.9702 7.16837 11.9642 7.13255 11.9523 7.10271Z",
    fill: "#023739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.09674C11.9523 7.10271 11.9523 7.10271 11.9523 7.09674Z",
    fill: "#023739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.10271V7.1624C11.9582 7.17433 11.9642 7.19224 11.9702 7.20418C11.9702 7.16837 11.9642 7.13255 11.9523 7.10271Z",
    fill: "#013133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.09674C11.9523 7.10271 11.9523 7.10271 11.9523 7.09674Z",
    fill: "#013133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 7.20418C11.9702 7.22805 11.9761 7.25193 11.9761 7.28177C11.9821 7.28774 11.994 7.28774 12 7.29371C11.994 7.26386 11.9821 7.23402 11.9702 7.20418Z",
    fill: "#023739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 7.20418C11.9702 7.22805 11.9761 7.2579 11.9761 7.28177C11.9761 7.2579 11.9761 7.22805 11.9702 7.20418Z",
    fill: "#013133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.1624V7.26983C11.9582 7.2758 11.9702 7.2758 11.9761 7.28177C11.9761 7.2579 11.9761 7.22805 11.9702 7.20418C11.9642 7.19224 11.9582 7.17433 11.9523 7.1624Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2984 18.5924C12.2208 18.6222 12.1313 18.6401 12.0418 18.6401V18.8371C12.1432 18.7715 12.2327 18.6879 12.2984 18.5924Z",
    fill: "#33B9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 18.6342H11.9582C11.9403 18.7297 11.9105 18.8192 11.8687 18.9028C11.9284 18.8849 11.9881 18.861 12.0418 18.8311V18.6342Z",
    fill: "#30ACB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3938 18.3715C12.2984 18.4193 12.185 18.4432 12.0716 18.4432H12.0418V18.6342C12.1313 18.6342 12.2208 18.6163 12.2984 18.5864C12.3401 18.5267 12.37 18.4491 12.3938 18.3715Z",
    fill: "#30ACB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 18.4491H11.9761V18.4909C11.9761 18.5387 11.9702 18.5864 11.9582 18.6342H12.0418V18.4491Z",
    fill: "#2DA2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4177 18.2104C12.3938 18.2164 12.37 18.2223 12.3461 18.2223H12.0716C12.0597 18.2343 12.0537 18.2462 12.0418 18.2581V18.4491H12.0716C12.185 18.4491 12.2984 18.4253 12.3938 18.3775C12.4058 18.3238 12.4117 18.2701 12.4177 18.2104Z",
    fill: "#2DA2AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4177 17.6434C12.3222 17.8463 12.2089 18.0433 12.0656 18.2223H12.3401C12.364 18.2223 12.3879 18.2164 12.4117 18.2104C12.4117 18.1985 12.4117 18.1925 12.4117 18.1806V17.6434",
    fill: "#2B9DA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 18.2581C12.0179 18.288 12 18.3119 11.9761 18.3417V18.4491H12.0418V18.2581Z",
    fill: "#2A979F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13078 18.6342C7.11884 18.7297 7.11288 18.8252 7.10691 18.9266H7.11288C7.11288 18.8311 7.11884 18.7297 7.13078 18.6342ZM7.18449 18.2223C7.17852 18.2581 7.17255 18.294 7.16658 18.3298C7.16658 18.294 7.17255 18.2581 7.18449 18.2223Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61412 16.9331C7.41124 17.333 7.26206 17.7687 7.18449 18.2223C7.26803 17.7627 7.41124 17.333 7.61412 16.9331Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9582 18.6342H11.8449C11.7792 18.7476 11.6837 18.849 11.5763 18.9266H11.6778C11.7434 18.9266 11.8091 18.9207 11.8687 18.9028C11.9045 18.8192 11.9403 18.7297 11.9582 18.6342Z",
    fill: "#2A979F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14868 18.6342H7.13078C7.11884 18.7297 7.11288 18.8252 7.11288 18.9266L7.13078 18.9266C7.13078 18.8311 7.13675 18.7297 7.14868 18.6342Z",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14868 18.6342C7.13675 18.7297 7.13078 18.8252 7.12481 18.9266C7.13078 18.8311 7.13675 18.7297 7.14868 18.6342Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8389 18.6342H11.63C11.463 18.7535 11.2601 18.8311 11.0393 18.8311C11.0333 18.8311 11.0333 18.8311 11.0273 18.8311H7.17255C7.17852 18.7655 7.17852 18.6998 7.19045 18.6342H7.14868C7.13675 18.7297 7.13078 18.8252 7.13078 18.9266L11.5763 18.9266C11.6778 18.849 11.7732 18.7476 11.8389 18.6342Z",
    fill: "#25868D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19045 18.2223C7.17852 18.2581 7.17255 18.294 7.16658 18.3298C7.14868 18.4312 7.13675 18.5327 7.13078 18.6342H7.13675C7.14271 18.4969 7.16062 18.3596 7.19045 18.2223Z",
    fill: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62009 16.9331H7.61412C7.41124 17.333 7.26803 17.7687 7.18449 18.2223H7.19045C7.27399 17.7687 7.41721 17.333 7.62009 16.9331Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19642 18.2223H7.18449C7.16062 18.3596 7.13675 18.4969 7.12481 18.6342H7.14272C7.14868 18.5685 7.15465 18.5088 7.16658 18.4432H7.16062C7.17255 18.3716 7.18449 18.294 7.19642 18.2223Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62009 16.9331C7.41721 17.333 7.26803 17.7687 7.18449 18.2223H7.19642C7.20239 18.1865 7.20835 18.1507 7.21432 18.1209H7.20835C7.29786 17.6971 7.43511 17.3032 7.62009 16.9331Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19045 18.4491H7.17255C7.16658 18.5088 7.15465 18.5745 7.14868 18.6401H7.19045C7.19045 18.6222 7.19642 18.6103 7.19642 18.5924H7.17852C7.17852 18.5387 7.18448 18.4969 7.19045 18.4491Z",
    fill: "#237F85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19642 18.2223C7.17852 18.2999 7.16658 18.3716 7.16062 18.4491H7.16658C7.17255 18.4253 7.17255 18.4014 7.17852 18.3835H7.17255C7.17852 18.3238 7.19045 18.2761 7.19642 18.2223Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22029 18.1209C7.21432 18.1567 7.20239 18.1925 7.19642 18.2223C7.20239 18.1865 7.21432 18.1507 7.22029 18.1209Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17852 18.3775C7.17255 18.4014 7.17255 18.4253 7.16658 18.4432C7.17255 18.4253 7.17852 18.4014 7.17852 18.3775Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19642 18.3775H7.17852C7.17255 18.4014 7.17255 18.4253 7.16658 18.4432H7.18449C7.19045 18.4253 7.19642 18.4014 7.19642 18.3775Z",
    fill: "#21797E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 18.4491H11.9224C11.8986 18.5148 11.8687 18.5805 11.8329 18.6401H11.9463C11.9523 18.5924 11.9582 18.5446 11.9642 18.4969V18.4491",
    fill: "#278E95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9284 18.4491H11.827C11.7732 18.5208 11.7076 18.5864 11.636 18.6401H11.8449C11.8747 18.5745 11.9045 18.5148 11.9284 18.4491Z",
    fill: "#237F85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 18.3357C11.9642 18.3417 11.9582 18.3536 11.9523 18.3596C11.9463 18.3895 11.9344 18.4193 11.9284 18.4432H11.9761V18.3357",
    fill: "#25868D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 18.3596C11.9463 18.3656 11.9403 18.3715 11.9344 18.3775H11.8687C11.8508 18.4014 11.8389 18.4253 11.821 18.4432H11.9224C11.9344 18.4193 11.9463 18.3895 11.9523 18.3596Z",
    fill: "#21797E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62009 16.9331C7.43511 17.3032 7.29189 17.7031 7.20835 18.1209H7.21432C7.22029 18.103 7.22029 18.0851 7.22626 18.0671H7.22029C7.3098 17.6613 7.44704 17.2853 7.62009 16.9331Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62606 16.9331C7.44704 17.2853 7.3098 17.6672 7.22626 18.0671H7.23222C7.25609 17.9537 7.28593 17.8463 7.31576 17.7389H7.3098C7.38737 17.4524 7.49478 17.1838 7.62606 16.9331Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31576 17.7329C7.28593 17.8403 7.25609 17.9478 7.23222 18.0612C7.25609 17.9537 7.27996 17.8403 7.31576 17.7329Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20835 18.4491H7.19045C7.18448 18.4969 7.17852 18.5446 7.17255 18.5924H7.19045C7.19642 18.5387 7.20239 18.4969 7.20835 18.4491Z",
    fill: "#1E6C71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22029 18.3775H7.20239C7.19642 18.4014 7.19642 18.4253 7.19045 18.4432H7.20835C7.21432 18.4253 7.21432 18.4014 7.22029 18.3775Z",
    fill: "#1D686D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.63 18.6342H7.18449C7.17852 18.6998 7.17255 18.7655 7.16658 18.8311H11.0214C11.0273 18.8311 11.0273 18.8311 11.0333 18.8311C11.2601 18.8311 11.4689 18.7595 11.63 18.6342Z",
    fill: "#21787E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 18.4491H11.5584C11.4092 18.5387 11.2362 18.5924 11.0512 18.5924C11.0393 18.5924 11.0273 18.5924 11.0214 18.5924H7.19642C7.19642 18.6103 7.19045 18.6222 7.19045 18.6401H11.636C11.7016 18.5805 11.7673 18.5208 11.827 18.4491Z",
    fill: "#207378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8747 18.3775H11.6599C11.63 18.4014 11.5942 18.4253 11.5584 18.4432H11.827C11.8389 18.4253 11.8568 18.4014 11.8747 18.3775Z",
    fill: "#1E6D73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5584 18.4491H7.20835C7.20239 18.4969 7.19642 18.5446 7.19045 18.5924H11.0154C11.0273 18.5924 11.0393 18.5924 11.0453 18.5924C11.2362 18.5864 11.4092 18.5387 11.5584 18.4491Z",
    fill: "#1C6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6539 18.3775H7.22029C7.21432 18.4014 7.21432 18.4253 7.20835 18.4432H11.5584C11.5942 18.4253 11.6241 18.4014 11.6539 18.3775Z",
    fill: "#1B6065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0656 18.2223H12.0358V18.2581C12.0477 18.2462 12.0597 18.2343 12.0656 18.2223Z",
    fill: "#2A979F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2208 7.46083V11.1912C12.2805 11.042 12.3461 10.8928 12.4177 10.7436V7.9622C12.4177 7.7712 12.3401 7.59214 12.2208 7.46083Z",
    fill: "#035053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4177 10.7436C12.3461 10.8868 12.2805 11.0361 12.2208 11.1912V14.2532C12.2864 14.2532 12.3521 14.2591 12.4177 14.2651V10.7436Z",
    fill: "#137377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2208 14.2532V17.0047C12.2208 17.0883 12.2029 17.1659 12.179 17.2375V17.3808C12.179 17.5419 12.1253 17.6911 12.0418 17.8165V18.2223L12.0716 18.2223C12.2089 18.0433 12.3282 17.8463 12.4237 17.6434V14.2651C12.3521 14.2591 12.2864 14.2591 12.2208 14.2532Z",
    fill: "#29939A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 18.2223L11.9761 18.2223C11.9761 18.2283 11.9761 18.2402 11.9761 18.2462V18.3357C12 18.3119 12.0239 18.282 12.0418 18.2522V18.2223Z",
    fill: "#288F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 17.8165L12.0358 17.8224V17.8582C12.0358 17.9657 12.0119 18.0671 11.9821 18.1626C11.9821 18.1806 11.9821 18.1985 11.9761 18.2223L12.0418 18.2223V17.8165Z",
    fill: "#278B92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 18.2223V18.2462C11.9702 18.2402 11.9761 18.2283 11.9761 18.2223Z",
    fill: "#237F86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 18.1626C11.9761 18.1686 11.9702 18.1746 11.9702 18.1806V18.2223C11.9761 18.2044 11.9761 18.1865 11.9761 18.1626Z",
    fill: "#237C83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 18.2462C11.9642 18.282 11.9582 18.3238 11.9523 18.3596C11.9582 18.3536 11.9642 18.3417 11.9702 18.3357V18.2462Z",
    fill: "#237F86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 18.2223H11.9523C11.9284 18.2761 11.8986 18.3298 11.8687 18.3835H11.9344C11.9403 18.3775 11.9463 18.3716 11.9523 18.3656C11.9642 18.3298 11.9702 18.288 11.9702 18.2522V18.2223Z",
    fill: "#207379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 18.1806C11.9642 18.1925 11.9582 18.2044 11.9523 18.2223H11.9702V18.1806Z",
    fill: "#1F7177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20239 18.2223H7.19642C7.18449 18.2761 7.17852 18.3298 7.17255 18.3835H7.17852C7.18448 18.3298 7.19642 18.2761 7.20239 18.2223Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22626 18.1209H7.22029C7.21432 18.1567 7.20835 18.1925 7.20239 18.2223L7.20835 18.2223C7.21432 18.1865 7.22029 18.1507 7.22626 18.1209Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20835 18.2223C7.19642 18.276 7.19045 18.3298 7.17852 18.3835C7.19045 18.3238 7.19642 18.276 7.20835 18.2223Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22626 18.2223L7.20835 18.2223C7.19642 18.276 7.19045 18.3298 7.18449 18.3835H7.20239C7.20835 18.3298 7.21432 18.2761 7.22626 18.2223Z",
    fill: "#207379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22626 18.1209C7.21432 18.1567 7.20835 18.1925 7.20239 18.2223C7.21432 18.1865 7.22029 18.1507 7.22626 18.1209Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24416 18.1209H7.22626C7.22029 18.1567 7.21432 18.1925 7.20835 18.2223L7.22626 18.2223C7.23222 18.1865 7.23819 18.1507 7.24416 18.1209Z",
    fill: "#1F7177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23819 18.0612H7.23222C7.22626 18.0791 7.22625 18.097 7.22029 18.1149H7.22626C7.23222 18.097 7.23222 18.0791 7.23819 18.0612Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23819 18.0612C7.23222 18.0791 7.22626 18.097 7.22626 18.1149C7.23222 18.097 7.23819 18.0791 7.23819 18.0612Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25609 18.0612H7.23819C7.23222 18.0791 7.23222 18.097 7.22626 18.1149H7.24416C7.25012 18.097 7.25609 18.0791 7.25609 18.0612Z",
    fill: "#1B6267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32173 17.7329H7.31576C7.28593 17.8403 7.25609 17.9478 7.23222 18.0612H7.23819C7.26206 17.9537 7.29189 17.8403 7.32173 17.7329Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32173 17.7329C7.28593 17.8403 7.26206 17.9478 7.23222 18.0612C7.26206 17.9537 7.29189 17.8403 7.32173 17.7329Z",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3456 17.7329H7.3277C7.29786 17.8403 7.26803 17.9478 7.24416 18.0612H7.26206C7.27996 17.9776 7.30383 17.8881 7.3277 17.8045C7.3277 17.7807 7.33366 17.7568 7.3456 17.7329Z",
    fill: "#18585D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24416 18.2223H7.22626C7.21432 18.2761 7.20835 18.3298 7.19642 18.3835H7.21432C7.22626 18.3238 7.23819 18.2761 7.24416 18.2223Z",
    fill: "#1C6369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25012 18.1209C7.24416 18.1567 7.23222 18.1925 7.22626 18.2223H7.24416C7.25012 18.1925 7.25609 18.1626 7.26206 18.1328H7.24416C7.24416 18.1268 7.24416 18.1209 7.25012 18.1209Z",
    fill: "#1B6267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26206 18.0612C7.25609 18.0791 7.25609 18.097 7.25012 18.1149C7.25012 18.097 7.25609 18.0791 7.26206 18.0612Z",
    fill: "#18585D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32173 17.8045C7.29786 17.8881 7.27399 17.9776 7.25609 18.0612C7.27996 17.9776 7.29786 17.8941 7.32173 17.8045Z",
    fill: "#175256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 17.8284C12.0239 17.8403 12.0179 17.8523 12.006 17.8702C12 17.8941 11.994 17.9179 11.9821 17.9418V18.1507C11.9821 18.1567 11.9821 18.1626 11.9821 18.1686C12.0179 18.0731 12.0358 17.9716 12.0358 17.8642V17.8284Z",
    fill: "#237D83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 17.9358C11.9761 17.9418 11.9702 17.9478 11.9702 17.9537V18.1806C11.9702 18.1746 11.9761 18.1686 11.9761 18.1626C11.9761 18.1567 11.9761 18.1507 11.9761 18.1447V17.9358Z",
    fill: "#1F7177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9582 18.2223H11.821C11.7732 18.282 11.7195 18.3357 11.6599 18.3835H11.8747C11.9045 18.3298 11.9344 18.2761 11.9582 18.2223Z",
    fill: "#1D696E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 17.9537C11.9344 18.0492 11.8807 18.1388 11.815 18.2164H11.9523C11.9582 18.2044 11.9642 18.1925 11.9702 18.1746V17.9537Z",
    fill: "#1D676C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.8642C11.994 17.8761 11.9821 17.8821 11.9761 17.8881V17.9358C11.9881 17.912 11.994 17.8881 12 17.8642Z",
    fill: "#1E6A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 17.8941L11.9702 17.9V17.9597C11.9702 17.9537 11.9761 17.9478 11.9761 17.9418V17.8941Z",
    fill: "#1B6267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 18.2223H7.24416C7.23222 18.2761 7.22625 18.3298 7.22029 18.3835H11.6539C11.7136 18.3357 11.7673 18.282 11.815 18.2223Z",
    fill: "#1A5D62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 17.9C11.8329 18.0433 11.642 18.1328 11.4271 18.1328H7.26206C7.25609 18.1626 7.25012 18.1925 7.24416 18.2223H11.815C11.8807 18.1447 11.9344 18.0552 11.9702 17.9597V17.9Z",
    fill: "#1A5C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.179 17.2375C12.1492 17.327 12.1014 17.4046 12.0418 17.4762V17.8165C12.1313 17.6911 12.179 17.5419 12.179 17.3808V17.2375Z",
    fill: "#248389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 17.4762V17.6255C12.0418 17.6493 12.0418 17.6792 12.0358 17.7031V17.8224L12.0418 17.8165V17.4762Z",
    fill: "#237C83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 17.4762L12.0298 17.4822V17.7031C12.0298 17.6792 12.0358 17.6493 12.0358 17.6255V17.4762Z",
    fill: "#1E6A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3456 17.7329C7.33963 17.7568 7.33366 17.7807 7.3277 17.8045C7.3277 17.7807 7.33366 17.7568 7.3456 17.7329Z",
    fill: "#175458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26803 18.1209H7.25012C7.25012 18.1268 7.25012 18.1268 7.25012 18.1328H7.26803C7.26206 18.1268 7.26803 18.1209 7.26803 18.1209Z",
    fill: "#195C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27996 18.0612H7.26206C7.25609 18.0791 7.25609 18.097 7.25012 18.1149H7.26803C7.26803 18.097 7.27399 18.0791 7.27996 18.0612Z",
    fill: "#175458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3635 17.7329H7.3456C7.33963 17.7568 7.33366 17.7807 7.3277 17.8045C7.30383 17.8881 7.28593 17.9776 7.26206 18.0612H7.27996C7.30383 17.9537 7.33367 17.8403 7.3635 17.7329Z",
    fill: "#164E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 17.7031C12.0298 17.7568 12.0179 17.8105 12.006 17.8642C12.0179 17.8523 12.0298 17.8403 12.0358 17.8224V17.7031Z",
    fill: "#1F7176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 17.4822C12.0179 17.5001 12 17.518 11.9821 17.5359V17.8881C11.9881 17.8821 12 17.8702 12.006 17.8642C12.0179 17.8105 12.0298 17.7568 12.0358 17.7031V17.4822Z",
    fill: "#1B6267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 17.5359L11.9702 17.5419V17.8941L11.9761 17.8881V17.5359Z",
    fill: "#1A5C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 17.5479C11.9284 17.5837 11.8866 17.6135 11.8389 17.6434C11.6658 17.9299 11.3555 18.1209 10.9975 18.1209C10.9915 18.1209 10.9856 18.1209 10.9796 18.1209H7.26803C7.26803 18.1268 7.26803 18.1268 7.26803 18.1328H11.4331C11.6479 18.1328 11.8389 18.0433 11.9761 17.9V17.5479",
    fill: "#18565B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8389 17.6374C11.821 17.6493 11.7971 17.6613 11.7732 17.6672C11.5942 17.906 11.3078 18.0612 10.9856 18.0612H7.27996C7.27399 18.0791 7.27399 18.097 7.26803 18.1149H10.9796C10.9856 18.1149 10.9915 18.1149 10.9975 18.1149C11.3555 18.1209 11.6718 17.9239 11.8389 17.6374Z",
    fill: "#165054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7792 17.6732C11.6897 17.715 11.5883 17.7389 11.4809 17.7389H7.3635C7.33367 17.8463 7.30383 17.9537 7.27996 18.0671H10.9856C11.3078 18.0612 11.5942 17.912 11.7792 17.6732Z",
    fill: "#154B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.179 7.41308C12.179 7.41905 12.179 7.41905 12.179 7.41308V11.2987C12.1909 11.2629 12.2088 11.2211 12.2208 11.1853V7.46083C12.2088 7.44292 12.1909 7.43099 12.179 7.41308Z",
    fill: "#024345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2208 11.1912C12.2088 11.2271 12.1909 11.2688 12.179 11.3047V14.2532C12.1909 14.2532 12.2088 14.2532 12.2208 14.2532V11.1912Z",
    fill: "#106064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.179 14.2532V17.2375C12.2029 17.1659 12.2208 17.0883 12.2208 17.0047V14.2532C12.2088 14.2532 12.1909 14.2532 12.179 14.2532Z",
    fill: "#227B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62606 16.9331C7.50075 17.1898 7.39334 17.4583 7.3098 17.7389H7.31576C7.33963 17.6672 7.35753 17.5956 7.3814 17.524C7.42914 17.3927 7.47688 17.2673 7.53058 17.142H7.52461C7.55445 17.0704 7.59025 16.9988 7.62606 16.9331Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3814 17.524C7.35753 17.5956 7.33366 17.6672 7.31576 17.7389C7.33366 17.6613 7.35753 17.5897 7.3814 17.524Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53058 17.136C7.47688 17.2614 7.42317 17.3867 7.3814 17.518C7.42914 17.3927 7.47688 17.2614 7.53058 17.136Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54252 17.136H7.53058C7.47688 17.2614 7.42317 17.3867 7.3814 17.518C7.35753 17.5897 7.33366 17.6613 7.31576 17.7329H7.32173C7.3814 17.53 7.45898 17.327 7.54252 17.136Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56042 17.136H7.54252C7.45898 17.327 7.3814 17.53 7.32173 17.7329H7.33963C7.40527 17.53 7.47688 17.327 7.56042 17.136Z",
    fill: "#175256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.29371C12.0239 7.3713 12.0358 7.45486 12.0358 7.54439V8.70231C12.0358 8.70828 12.0358 8.71425 12.0358 8.72022V11.7404C12.0776 11.5971 12.1253 11.4539 12.173 11.3106V7.41905C12.1253 7.36533 12.0656 7.32355 12 7.29371Z",
    fill: "#023D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.179 11.3047C12.1253 11.4479 12.0835 11.5911 12.0418 11.7344V14.2472C12.0895 14.2472 12.1372 14.2472 12.179 14.2532V11.3047Z",
    fill: "#0F575A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0418 14.2472V17.4762C12.1014 17.4046 12.1492 17.327 12.179 17.2375V14.2532C12.1313 14.2472 12.0835 14.2472 12.0418 14.2472Z",
    fill: "#1F6F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 8.70231V11.7404V8.71425C12.0418 8.70828 12.0418 8.70828 12.0358 8.70231Z",
    fill: "#023A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 7.28177C11.9761 7.28774 11.9761 7.29371 11.9761 7.29968V7.46083C12.0119 7.55633 12.0298 7.6578 12.0298 7.76523V8.63069C12.0298 8.65456 12.0358 8.67844 12.0358 8.69634V7.53842C12.0358 7.44889 12.0239 7.36533 12 7.28774C11.994 7.28774 11.9881 7.28774 11.9761 7.28177Z",
    fill: "#013537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 8.63069V11.7583C12.0358 11.7523 12.0418 11.7463 12.0418 11.7404V8.70231C12.0358 8.67844 12.0358 8.65456 12.0358 8.63069Z",
    fill: "#013335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 11.7344C12.0358 11.7404 12.0298 11.7463 12.0298 11.7523V14.2472H12.0358L12.0358 11.7344Z",
    fill: "#0C4A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 14.2472V17.4822L12.0418 17.4762L12.0358 14.2472Z",
    fill: "#1A5E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.26983V7.40114C11.9582 7.41905 11.9702 7.44292 11.9761 7.46083V7.29968C11.9761 7.29371 11.9761 7.28774 11.9761 7.28177C11.9702 7.2758 11.9642 7.2758 11.9523 7.26983Z",
    fill: "#012C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58429 17.1301H7.56638C7.47688 17.3211 7.40527 17.524 7.3456 17.7329H7.3635C7.42317 17.53 7.50075 17.327 7.58429 17.1301Z",
    fill: "#144A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 7.46083V8.40388C12 8.4755 12.0239 8.5531 12.0298 8.63069V7.76523C12.0298 7.6578 12.0119 7.55633 11.9761 7.46083Z",
    fill: "#013133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 8.40388V11.9672C11.994 11.8955 12.0119 11.8299 12.0298 11.7583V8.63666C12.0239 8.5531 12.006 8.4755 11.9761 8.40388Z",
    fill: "#013032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 11.7583C12.0179 11.8299 12 11.8955 11.9821 11.9672V14.2472C11.9881 14.2472 11.994 14.2472 12 14.2472C12.0119 14.2472 12.0239 14.2472 12.0358 14.2472V11.7583Z",
    fill: "#0C4548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.994 14.2472C11.9881 14.2472 11.9821 14.2472 11.9761 14.2472V17.0883V17.5359C11.994 17.518 12.0119 17.5001 12.0298 17.4822V14.2472C12.0239 14.2472 12.006 14.2472 11.994 14.2472Z",
    fill: "#19595D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 17.0883C11.9761 17.0943 11.9761 17.1062 11.9761 17.1122V17.1539C11.9761 17.1838 11.9761 17.2136 11.9702 17.2494V17.5419L11.9761 17.5359V17.0883Z",
    fill: "#175357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 17.2494C11.9523 17.3927 11.9105 17.524 11.8389 17.6374C11.8866 17.6135 11.9284 17.5777 11.9702 17.5419V17.2494Z",
    fill: "#165054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 17.1122C11.9761 17.136 11.9702 17.1659 11.9702 17.1898V17.2494C11.9761 17.2196 11.9761 17.1898 11.9761 17.1539V17.1122Z",
    fill: "#164E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 17.1898C11.9463 17.3688 11.8807 17.5359 11.7732 17.6732C11.7971 17.6613 11.815 17.6553 11.8389 17.6434C11.9105 17.53 11.9523 17.3927 11.9702 17.2554V17.1898Z",
    fill: "#154B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 7.46083V7.99801C11.9761 8.00398 11.9761 8.01592 11.9761 8.02189V8.39791V7.46083Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 7.99801V8.39791V8.02189C11.9761 8.01592 11.9761 8.00995 11.9761 7.99801Z",
    fill: "#012C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 8.39791V11.9672C11.9761 11.9672 11.9761 11.9672 11.9761 11.9612V8.39791C11.9761 8.40388 11.9761 8.40388 11.9761 8.39791Z",
    fill: "#012A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 14.2472V17.1122C11.9761 17.1062 11.9761 17.0943 11.9761 17.0883V14.2472Z",
    fill: "#164E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.40114V7.82492C11.9642 7.88461 11.9702 7.93832 11.9761 7.99801V7.46083C11.9702 7.43696 11.9642 7.41905 11.9523 7.40114Z",
    fill: "#012A2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.82492V8.18901C11.9642 8.23676 11.9702 8.29048 11.9702 8.33822V8.38001C11.9702 8.38597 11.9761 8.39194 11.9761 8.39791V7.99801C11.9761 7.93832 11.9702 7.87864 11.9523 7.82492Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 8.38597V11.997C11.9702 11.991 11.9761 11.9791 11.9761 11.9731V8.40388C11.9761 8.39791 11.9761 8.39194 11.9702 8.38597Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 11.9672C11.9761 11.9731 11.9702 11.9851 11.9702 11.991V14.2472H11.9761V11.9672Z",
    fill: "#0A3A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 14.2472H11.9702V17.1898C11.9702 17.1659 11.9761 17.142 11.9761 17.1122V14.2472Z",
    fill: "#144A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 7.81895V8.18304C11.9523 8.18304 11.9523 8.18304 11.9523 8.18901V7.81895C11.9523 7.82492 11.9523 7.82492 11.9523 7.81895Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 8.18901V8.34419C11.9582 8.35613 11.9642 8.37404 11.9702 8.38597V8.34419C11.9702 8.29048 11.9642 8.23676 11.9523 8.18901Z",
    fill: "#012829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 8.34419V12.0686C11.9582 12.0448 11.9642 12.0209 11.9702 11.997V8.38597C11.9642 8.36807 11.9582 8.35613 11.9523 8.34419Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 11.991C11.9642 12.0149 11.9582 12.0388 11.9523 12.0627V14.2412C11.9582 14.2412 11.9642 14.2412 11.9702 14.2412V11.991Z",
    fill: "#09393B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9702 14.2472C11.9642 14.2472 11.9582 14.2472 11.9523 14.2472V15.6319C11.9523 15.6379 11.9523 15.6439 11.9523 15.6498V16.0259C11.9523 16.4317 10.8364 16.7958 10.4306 16.7958L7.58429 17.1301C7.49478 17.327 7.42317 17.524 7.3635 17.7329H11.4809C11.5883 17.7329 11.6897 17.709 11.7792 17.6672C11.8807 17.53 11.9523 17.3688 11.9761 17.1838V14.2472",
    fill: "#14494C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 8.34419V12.0746C11.9523 12.0746 11.9523 12.0746 11.9523 12.0686V8.34419Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 14.2472L11.9523 15.6439C11.9523 15.6379 11.9523 15.6319 11.9523 15.626L11.9523 14.2472Z",
    fill: "#14484C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2293C11.7852 14.2293 11.7434 14.2293 11.7076 14.2353C11.6718 14.2353 11.636 14.2412 11.6002 14.2412C11.087 14.283 10.5977 14.3964 10.1442 14.5814C10.4127 14.474 10.6992 14.3905 10.9856 14.3367C11.2601 14.277 11.5405 14.2472 11.827 14.2353V14.2293Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7016 14.2353C11.6658 14.2353 11.63 14.2412 11.5942 14.2412C11.63 14.2412 11.6658 14.2412 11.7016 14.2353Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2353C11.5405 14.2472 11.2601 14.277 10.9856 14.3367C10.9975 14.3367 11.0094 14.3308 11.0154 14.3308C11.1765 14.3009 11.3376 14.277 11.5047 14.2591C11.6121 14.2532 11.7195 14.2412 11.827 14.2353Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5047 14.2591C11.3376 14.277 11.1765 14.3009 11.0154 14.3308C11.099 14.3129 11.1765 14.3009 11.2601 14.289C11.2959 14.283 11.3317 14.277 11.3675 14.277C11.4092 14.2711 11.457 14.2651 11.5047 14.2591Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3675 14.277C11.3317 14.283 11.2959 14.289 11.2601 14.289C11.278 14.289 11.2959 14.283 11.3138 14.283C11.3317 14.283 11.3496 14.283 11.3675 14.277Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2412C11.7195 14.2472 11.6121 14.2532 11.5047 14.2651C11.457 14.2711 11.4152 14.277 11.3675 14.283C11.5167 14.2591 11.6718 14.2472 11.827 14.2412Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2412C11.6718 14.2472 11.5167 14.2591 11.3675 14.277C11.3496 14.277 11.3317 14.283 11.3197 14.283C11.4868 14.2651 11.6539 14.2532 11.827 14.2412Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20686 6.02835C4.14719 6.41631 4.11735 6.79831 4.11735 7.17433C4.11735 7.05496 4.12332 6.93559 4.12929 6.81621V6.80428C4.12929 6.79234 4.12929 6.7804 4.12929 6.76847C4.14719 6.51778 4.17106 6.2671 4.20686 6.02835Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28444 5.65829L4.27847 5.65829C4.2546 5.78364 4.23073 5.90301 4.21283 6.02835C4.17703 6.27307 4.14719 6.51778 4.13526 6.76847C4.14122 6.63715 4.15316 6.50584 4.17106 6.37453C4.18896 6.19547 4.2188 6.01641 4.24863 5.83735C4.26057 5.77767 4.2725 5.71798 4.28444 5.65829Z",
    fill: "#036569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1586 5.65829H4.28444C4.2725 5.71798 4.26057 5.77767 4.24863 5.84332H4.70214C4.75584 5.80751 4.82745 5.7896 4.89309 5.7896H11.5704C11.457 5.70604 11.3138 5.65829 11.1586 5.65829Z",
    fill: "#036468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89905 5.78364C4.82745 5.78364 4.76181 5.80154 4.70811 5.83735H11.2064C11.3913 5.83735 11.5584 5.90301 11.6897 6.01641H11.8031C11.7494 5.92688 11.6718 5.84332 11.5823 5.78364H4.90502C4.89906 5.78364 4.89905 5.78364 4.89905 5.78364Z",
    fill: "#036164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7971 6.01641H11.6837C11.7792 6.09401 11.8508 6.19547 11.8986 6.30888C11.8866 6.20144 11.8508 6.10594 11.7971 6.01641Z",
    fill: "#035B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 6.79831V6.81025C4.12929 6.81025 4.12929 6.80428 4.12929 6.79831Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2233C11.8449 14.2233 11.8329 14.2233 11.827 14.2233L11.827 14.2293C11.8329 14.2293 11.8449 14.2293 11.8508 14.2293V14.2233Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2174C11.8449 14.2174 11.8329 14.2174 11.827 14.2233C11.8329 14.2233 11.8449 14.2233 11.8508 14.2174Z",
    fill: "#036165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2174H11.8329H11.827C11.8329 14.2233 11.8449 14.2174 11.8508 14.2174Z",
    fill: "#036164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2233H11.8508V14.2293H11.8568V14.2233Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2174C11.8508 14.2174 11.8508 14.2174 11.8508 14.2174V14.2233C11.8508 14.2233 11.8568 14.2233 11.8568 14.2174Z",
    fill: "#025558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2174C11.8449 14.2174 11.8389 14.2174 11.8329 14.2174H11.8508Z",
    fill: "#024F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13526 6.76847C4.13526 6.7804 4.13526 6.79234 4.13526 6.80428C4.13526 6.78637 4.13526 6.7804 4.13526 6.76847Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16509 6.37453C4.15316 6.50584 4.14122 6.63715 4.12929 6.76847C4.12929 6.7804 4.12929 6.79234 4.12929 6.80428C4.14122 6.66103 4.15316 6.51778 4.16509 6.37453Z",
    fill: "#025154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 6.81621C4.12332 6.93559 4.11735 7.05496 4.11735 7.17433C4.11735 7.49067 4.14122 7.80104 4.18299 8.10545C4.13526 7.73539 4.11139 7.36533 4.12332 6.98334C4.12332 6.92962 4.12332 6.8759 4.12929 6.82218V6.81621Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 6.82218C4.12929 6.8759 4.12332 6.92962 4.12332 6.98334C4.12332 6.93559 4.12332 6.88784 4.12929 6.84009L4.12929 6.82218Z",
    fill: "#025154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 6.79831C4.12929 6.80428 4.12929 6.81025 4.12929 6.81025V6.82218C4.12929 6.81622 4.12929 6.81025 4.12929 6.79831Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13526 6.79831C4.13526 6.80428 4.13526 6.81622 4.13526 6.82218V6.84009C4.12929 6.82815 4.13526 6.81621 4.13526 6.79831Z",
    fill: "#02484B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01641 13.8891C9.06415 13.907 9.11188 13.9189 9.16559 13.9368C9.13575 13.9309 9.11188 13.9189 9.08205 13.913C9.05818 13.907 9.03431 13.901 9.01641 13.8891Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08205 13.913C9.11188 13.9189 9.13575 13.9309 9.16559 13.9368C9.35654 13.9965 9.55346 14.0443 9.75634 14.092C10.2039 14.1875 10.6634 14.2412 11.1228 14.2412C10.9498 14.2412 10.7767 14.2293 10.6037 14.2174C10.55 14.2114 10.4963 14.2054 10.4426 14.1995C10.2397 14.1756 10.0368 14.1457 9.83391 14.104C9.57732 14.0562 9.3267 13.9906 9.08205 13.913Z",
    fill: "#025053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83391 14.104C10.0308 14.1457 10.2337 14.1756 10.4426 14.1995C10.4963 14.2054 10.55 14.2114 10.6037 14.2174C10.3769 14.1995 10.1502 14.1636 9.92342 14.1219H9.91745C9.88762 14.1159 9.85778 14.1099 9.83391 14.104Z",
    fill: "#023A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2114C11.8449 14.2114 11.8329 14.2114 11.827 14.2174H11.8329C11.8389 14.2174 11.8449 14.2174 11.8508 14.2114Z",
    fill: "#024144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2114C11.8449 14.2114 11.8329 14.2114 11.827 14.2174C11.8329 14.2174 11.8449 14.2174 11.8508 14.2114Z",
    fill: "#023E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2114H11.8508C11.8508 14.2174 11.8568 14.2174 11.8568 14.2114Z",
    fill: "#023B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2114C11.8449 14.2114 11.8329 14.2114 11.827 14.2174C11.8329 14.2174 11.8449 14.2174 11.8508 14.2114Z",
    fill: "#012E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2114C11.8449 14.2114 11.8389 14.2114 11.8329 14.2114C11.827 14.2114 11.827 14.2114 11.821 14.2114C11.8329 14.2174 11.8449 14.2114 11.8508 14.2114Z",
    fill: "#012C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8329 14.2174C11.827 14.2174 11.827 14.2174 11.821 14.2174C11.827 14.2174 11.8329 14.2174 11.8329 14.2174Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1442 14.5814C9.04028 15.0112 8.11537 15.8408 7.57235 16.9331L7.60815 16.9271C7.85878 16.4258 8.18697 15.9781 8.5808 15.6021C9.02238 15.1723 9.55345 14.8202 10.1442 14.5814Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57484 15.6081C8.181 15.9901 7.84684 16.4377 7.60219 16.9331H7.60815C7.85878 16.4377 8.18697 15.9901 8.57484 15.6081Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2293C11.8449 14.2293 11.8329 14.2293 11.827 14.2293V14.2353C11.8329 14.2353 11.8449 14.2353 11.8508 14.2353V14.2293Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2293H11.8508V14.2353H11.8568V14.2293Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2233V14.2293V14.2353V14.2233Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2174C11.8568 14.2233 11.8568 14.2233 11.8568 14.2174Z",
    fill: "#024043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9856 14.3367C10.6992 14.3964 10.4127 14.474 10.1442 14.5814C9.55942 14.8202 9.02834 15.1664 8.5808 15.6021C9.22526 14.9813 10.0428 14.5337 10.9438 14.3427C10.9557 14.3427 10.9677 14.3427 10.9856 14.3367Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9378 14.3487C10.0368 14.5397 9.21929 14.9813 8.57484 15.6081C8.181 15.9901 7.85281 16.4377 7.60815 16.9331C7.91845 16.3124 8.36002 15.7692 8.89707 15.3335C9.3267 14.9873 9.81601 14.7068 10.3411 14.5218C10.538 14.4501 10.735 14.3905 10.9378 14.3487Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3471 14.5158C9.81601 14.7008 9.3267 14.9813 8.90303 15.3275C9.20139 15.0888 9.52362 14.8799 9.87568 14.7128C10.0249 14.6411 10.186 14.5755 10.3471 14.5158Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89707 15.3275C8.36002 15.7632 7.91845 16.3064 7.60815 16.9271H7.61412C7.92442 16.3064 8.36599 15.7632 8.89707 15.3275Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86972 14.7187C9.51765 14.8859 9.19542 15.0888 8.89707 15.3335C8.36599 15.7692 7.92441 16.3124 7.60815 16.9391H7.61412C7.66783 16.8316 7.7275 16.7242 7.78717 16.6227C7.99602 16.2706 8.25261 15.9483 8.53903 15.6618C8.93287 15.2738 9.38041 14.9515 9.86972 14.7187Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55097 15.6558C8.26454 15.9423 8.00796 16.2646 7.7991 16.6168C8.00199 16.2765 8.24664 15.9602 8.5271 15.6797C8.53307 15.6737 8.53903 15.6618 8.55097 15.6558Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52113 15.6797C8.24068 15.9602 7.99602 16.2765 7.79314 16.6168C7.73347 16.7182 7.67379 16.8257 7.62009 16.9331C7.84684 16.4855 8.13923 16.0796 8.47936 15.7215C8.49726 15.7095 8.5092 15.6916 8.52113 15.6797Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48533 15.7215C8.13923 16.0736 7.85281 16.4795 7.62606 16.9331C7.76927 16.6466 7.93635 16.378 8.13327 16.1333C8.22874 16.008 8.33018 15.8886 8.43759 15.7752C8.44953 15.7573 8.46743 15.7394 8.48533 15.7215Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0154 14.3308C11.0035 14.3308 10.9915 14.3367 10.9856 14.3367C10.9736 14.3367 10.9557 14.3427 10.9438 14.3487C10.9677 14.3427 10.9915 14.3367 11.0154 14.3308Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2601 14.295C11.1765 14.3069 11.099 14.3188 11.0154 14.3367C10.9915 14.3427 10.9677 14.3487 10.9378 14.3546C10.735 14.3964 10.538 14.4561 10.3411 14.5277C10.6395 14.4143 10.9438 14.3367 11.2601 14.295Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3138 14.283C11.2959 14.283 11.278 14.289 11.2601 14.289C10.9438 14.3367 10.6395 14.4084 10.3471 14.5158C10.186 14.5755 10.0249 14.6411 9.87568 14.7128C10.2158 14.5516 10.5798 14.4263 10.9557 14.3487C11.0751 14.3248 11.1944 14.3009 11.3138 14.283Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9557 14.3487C10.5798 14.4263 10.2158 14.5516 9.87568 14.7128C9.38637 14.9515 8.93884 15.2678 8.55097 15.6498C8.60467 15.5961 8.66435 15.5424 8.71805 15.4887C9.27897 14.9873 9.95326 14.6113 10.6992 14.4084C10.7827 14.3905 10.8662 14.3725 10.9557 14.3487Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6992 14.4143C9.95326 14.6173 9.273 14.9933 8.71805 15.4947C9.26106 15.0052 9.91745 14.6411 10.6335 14.4322C10.6574 14.4263 10.6753 14.4203 10.6992 14.4143Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71805 15.4947C8.65838 15.5484 8.60467 15.6021 8.55097 15.6558C8.545 15.6618 8.53307 15.6737 8.5271 15.6797C8.58677 15.614 8.65241 15.5543 8.71805 15.4947Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6335 14.4322C9.91745 14.6352 9.26106 15.0052 8.71805 15.4947C8.65241 15.5543 8.58677 15.614 8.5271 15.6797C8.51517 15.6916 8.49726 15.7095 8.48533 15.7215C9.07011 15.1186 9.81004 14.671 10.6335 14.4322Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6275 14.4382C9.80408 14.6769 9.06415 15.1246 8.47936 15.7274C8.46146 15.7453 8.44356 15.7632 8.43162 15.7811C9.01641 15.1604 9.75634 14.7008 10.5798 14.4561C10.5977 14.4442 10.6156 14.4382 10.6275 14.4382Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2353C11.8449 14.2353 11.8329 14.2353 11.827 14.2353L11.827 14.2412C11.8329 14.2412 11.8449 14.2412 11.8508 14.2353Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2412C11.8449 14.2412 11.8329 14.2412 11.827 14.2412V14.2472C11.6539 14.2532 11.4868 14.2651 11.3197 14.283C11.2004 14.3009 11.0751 14.3248 10.9557 14.3487C11.2481 14.289 11.5465 14.2532 11.8508 14.2472V14.2412Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2353H11.8508L11.8508 14.2412C11.8508 14.2412 11.8568 14.2412 11.8568 14.2353Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2412H11.8508V14.2472C11.5465 14.2532 11.2422 14.289 10.9557 14.3487C10.8722 14.3666 10.7887 14.3905 10.7051 14.4143C11.0154 14.3308 11.3317 14.277 11.6658 14.2591C11.7315 14.2532 11.7971 14.2532 11.8628 14.2532V14.2412",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6599 14.2591C11.3317 14.283 11.0094 14.3367 10.6992 14.4143C10.6753 14.4203 10.6514 14.4263 10.6275 14.4322C10.6753 14.4203 10.723 14.4084 10.7708 14.3964C11.0214 14.3308 11.2839 14.289 11.5525 14.2651C11.5883 14.2591 11.6241 14.2591 11.6599 14.2591Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5525 14.2651C11.2839 14.289 11.0273 14.3308 10.7708 14.3964C11.0154 14.3367 11.2601 14.289 11.5167 14.2711C11.5346 14.2651 11.5405 14.2651 11.5525 14.2651Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5226 14.2651C11.266 14.289 11.0214 14.3308 10.7767 14.3905C10.729 14.4024 10.6813 14.4143 10.6335 14.4322C10.6156 14.4382 10.5977 14.4442 10.5798 14.4501C10.8841 14.3606 11.2004 14.3009 11.5226 14.2651Z",
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1273 16.1333C7.93635 16.384 7.7633 16.6466 7.62009 16.9331C7.76927 16.6466 7.93635 16.378 8.1273 16.1333Z",
    fill: "#6D6D6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 6.30888C11.8986 6.31485 11.8986 6.32082 11.8986 6.32678H11.9045C11.9045 6.32082 11.8986 6.31485 11.8986 6.30888Z",
    fill: "#03575A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 6.32678C11.9045 6.35066 11.9045 6.3805 11.9045 6.40438V6.66103H11.9463L11.9284 6.67297C11.9344 6.67297 11.9463 6.67297 11.9523 6.67297L11.9523 6.59537C11.9523 6.49988 11.9344 6.41035 11.9045 6.32678Z",
    fill: "#035255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9463 6.66103H11.9045V6.6849C11.9224 6.69684 11.9403 6.70281 11.9523 6.71475V6.67297C11.9463 6.67297 11.9344 6.67297 11.9284 6.67297L11.9463 6.66103Z",
    fill: "#034E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 6.6849V6.83412C11.9224 6.84606 11.9403 6.86396 11.9523 6.8759V6.71475C11.9403 6.70281 11.9224 6.69087 11.9045 6.6849Z",
    fill: "#024143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18896 8.10545C4.54102 10.6779 6.28941 12.8983 8.77772 13.8115C7.90055 13.4892 7.12481 13.0057 6.46246 12.4089C5.23322 11.2927 4.42168 9.7707 4.18896 8.10545Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46246 12.4029C7.12481 13.0057 7.90055 13.4832 8.77772 13.8055C8.8553 13.8354 8.93287 13.8592 9.01641 13.8891C8.04376 13.5727 7.18448 13.0594 6.46246 12.4029Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1288 14.2412C11.1527 14.2412 11.1825 14.2412 11.2064 14.2412C11.2183 14.2412 11.2243 14.2412 11.2362 14.2412C11.2302 14.2412 11.2243 14.2412 11.2183 14.2412C11.2064 14.2412 11.1944 14.2412 11.1825 14.2412C11.1646 14.2412 11.1467 14.2412 11.1288 14.2412Z",
    fill: "#024A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2362 14.2412C11.2302 14.2412 11.2243 14.2412 11.2123 14.2412C11.2064 14.2412 11.2004 14.2412 11.1944 14.2412C11.1885 14.2412 11.1885 14.2412 11.1825 14.2412C11.1944 14.2412 11.2064 14.2412 11.2183 14.2412C11.2243 14.2412 11.2302 14.2412 11.2362 14.2412C11.2362 14.2412 11.2422 14.2412 11.2481 14.2412C11.2481 14.2412 11.2422 14.2412 11.2362 14.2412C11.2422 14.2412 11.2422 14.2412 11.2362 14.2412Z",
    fill: "#023638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2541 14.2412H11.2481C11.2541 14.2412 11.2541 14.2412 11.2541 14.2412Z",
    fill: "#013234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.809 14.2174H11.8031C11.6241 14.2412 11.4391 14.2412 11.2541 14.2412C11.2601 14.2412 11.266 14.2412 11.272 14.2412C11.457 14.2412 11.636 14.2412 11.809 14.2174Z",
    fill: "#012E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2481 14.2412C11.2541 14.2412 11.2541 14.2412 11.2481 14.2412Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8031 14.2174H11.7792C11.6062 14.2412 11.4271 14.2412 11.2481 14.2412H11.2541C11.4391 14.2412 11.6241 14.2412 11.8031 14.2174Z",
    fill: "#012C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2174C11.821 14.2174 11.809 14.2174 11.8031 14.2233H11.8091C11.815 14.2174 11.821 14.2174 11.827 14.2174Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2114C11.8091 14.2114 11.7971 14.2174 11.7792 14.2174H11.8031C11.809 14.2174 11.821 14.2174 11.827 14.2114Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 6.82815V6.94156C11.9224 6.98931 11.9403 7.04302 11.9523 7.09674V6.8759C11.9403 6.858 11.9224 6.84606 11.9045 6.82815Z",
    fill: "#023B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 6.94156C11.9224 6.99527 11.9403 7.04302 11.9523 7.09674C11.9403 7.04302 11.9224 6.98931 11.9045 6.94156Z",
    fill: "#013436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 6.94156V7.06093C11.9224 7.09077 11.9403 7.12658 11.9523 7.15643L11.9523 7.09674C11.9403 7.04302 11.9284 6.99527 11.9045 6.94156Z",
    fill: "#012F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 7.0669V7.25193C11.9224 7.2579 11.9403 7.26387 11.9523 7.26983V7.1624C11.9403 7.12659 11.9224 7.09674 11.9045 7.0669Z",
    fill: "#012C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62606 16.9331C7.58429 16.9988 7.55445 17.0704 7.52461 17.142H7.53058C7.56042 17.0704 7.59622 16.9988 7.62606 16.9331Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63799 16.9271H7.62606C7.59025 16.9928 7.56042 17.0644 7.53058 17.136H7.54252C7.57235 17.0644 7.60815 16.9988 7.63799 16.9271Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64396 16.9271C7.60815 16.9928 7.57235 17.0644 7.54252 17.136H7.54848C7.57832 17.0644 7.60815 16.9988 7.64396 16.9271Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66186 16.9271H7.64396C7.60815 16.9928 7.57832 17.0644 7.54848 17.136H7.56638C7.59622 17.0644 7.62606 16.9928 7.66186 16.9271Z",
    fill: "#164E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 7.25193V7.29968C11.9224 7.32952 11.9403 7.36533 11.9523 7.40114L11.9523 7.2758C11.9403 7.26386 11.9224 7.2579 11.9045 7.25193Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66186 16.9271C7.62606 16.9928 7.59025 17.0644 7.56042 17.136H7.56638C7.59622 17.0644 7.63202 16.9928 7.66186 16.9271Z",
    fill: "#154C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68573 16.9271H7.66783C7.63202 16.9928 7.60219 17.0644 7.56638 17.136H7.58429C7.61412 17.0584 7.64993 16.9928 7.68573 16.9271Z",
    fill: "#14484C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 7.29968V7.66376C11.9224 7.71151 11.9403 7.76523 11.9523 7.81895V7.40114C11.9403 7.36533 11.9224 7.32952 11.9045 7.29968Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 7.66376V8.01592C11.9284 8.06963 11.9403 8.12932 11.9523 8.18304V7.81895C11.9403 7.76523 11.9224 7.71748 11.9045 7.66376Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 15.6498C11.9463 15.6976 11.9344 15.7394 11.9045 15.7871V15.8408C11.9045 16.2467 10.7887 16.6108 10.3829 16.6108L7.67976 16.9271C7.64396 16.9928 7.61412 17.0644 7.58429 17.136L10.4306 16.7958C10.8364 16.7958 11.9523 16.4377 11.9523 16.0259V15.6498Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 8.01592V8.24869C11.9224 8.27854 11.9403 8.31435 11.9523 8.34419V8.18901C11.9403 8.12932 11.9284 8.06963 11.9045 8.01592Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 8.24869V12.3193C11.9165 12.2358 11.9344 12.1582 11.9523 12.0746V8.34419C11.9403 8.30838 11.9224 8.27854 11.9045 8.24869Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 12.0686C11.9344 12.1522 11.9165 12.2298 11.9045 12.3134V14.2472C11.9224 14.2472 11.9344 14.2472 11.9523 14.2472L11.9523 12.0686Z",
    fill: "#09373A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9523 14.2472C11.9344 14.2472 11.9224 14.2472 11.9045 14.2472V15.7811C11.9344 15.7394 11.9523 15.6916 11.9523 15.6439L11.9523 14.2472Z",
    fill: "#14474B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24863 5.83735C4.21283 6.01641 4.18896 6.19547 4.17106 6.37453C4.17703 6.30888 4.18896 6.24919 4.19493 6.18354C4.20686 6.07013 4.22476 5.95673 4.24863 5.83735Z",
    fill: "#035B5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.70214 5.83735L4.24863 5.83735C4.22476 5.95076 4.20686 6.06416 4.19493 6.18354C4.20089 6.12982 4.21283 6.0761 4.2188 6.02238H4.54102C4.54699 6.02238 4.54699 6.02238 4.55296 6.02238C4.58279 5.94479 4.6365 5.87913 4.70214 5.83735Z",
    fill: "#035B5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2004 5.83735H4.70214C4.6365 5.87913 4.58279 5.94479 4.55296 6.01641C4.57086 6.01641 4.58876 6.01045 4.60666 6.01045H11.6837C11.5525 5.90301 11.3854 5.83735 11.2004 5.83735Z",
    fill: "#03585B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54102 6.02238C4.54699 6.02238 4.54699 6.02238 4.55296 6.02238H4.54102Z",
    fill: "#035558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6837 6.01641H4.60666C4.58876 6.01641 4.57086 6.01641 4.55296 6.02238H10.0547C10.4187 6.02238 10.7767 6.11191 11.099 6.285C11.1109 6.29694 11.1288 6.31485 11.1586 6.32678H11.9045C11.9045 6.32082 11.9045 6.31485 11.9045 6.30888C11.8508 6.19547 11.7792 6.09401 11.6837 6.01641Z",
    fill: "#035255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 6.32678H11.1527C11.1706 6.33872 11.1885 6.34469 11.2123 6.35663C11.3317 6.38647 11.4451 6.43422 11.5465 6.49988C11.6539 6.54762 11.7673 6.60134 11.8687 6.65506H11.9045V6.39841C11.9045 6.3805 11.9045 6.35066 11.8986 6.32678Z",
    fill: "#034E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2183 6.35663C11.3018 6.39841 11.4212 6.44616 11.5525 6.49988C11.451 6.43422 11.3376 6.38647 11.2183 6.35663Z",
    fill: "#02383A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 6.66103H11.8687C11.8807 6.667 11.8926 6.67297 11.9045 6.6849V6.66103Z",
    fill: "#03494C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18896 6.18354C4.17703 6.24919 4.17106 6.30888 4.16509 6.37453C4.14719 6.51778 4.13526 6.66103 4.12929 6.80428C4.14719 6.59537 4.16509 6.39244 4.18896 6.18354Z",
    fill: "#024A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 6.98334C4.11735 7.35936 4.14122 7.73539 4.18896 8.10545C4.42168 9.7707 5.23322 11.2927 6.46246 12.4029C5.818 11.812 5.28095 11.1137 4.89309 10.3377C4.40378 9.3708 4.12929 8.27854 4.12929 7.12062C4.12332 7.07884 4.12332 7.03109 4.12929 6.98334Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 6.84606C4.12929 6.89381 4.12332 6.94156 4.12332 6.98931C4.12332 7.03706 4.12332 7.07884 4.12332 7.12658C4.12332 8.28451 4.39781 9.37677 4.88712 10.3437C4.35604 9.29321 4.08752 8.11142 4.12929 6.89381V6.84606Z",
    fill: "#024A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54102 6.02238H4.2188C4.21283 6.0761 4.20089 6.12982 4.19493 6.18354C4.16509 6.39244 4.14719 6.59537 4.13526 6.79831C4.14122 6.64312 4.15316 6.48794 4.17106 6.33275H4.23073C4.26057 6.1716 4.38588 6.04626 4.54102 6.02238Z",
    fill: "#024A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55296 6.02238H4.54102C4.38588 6.05223 4.26057 6.17757 4.23073 6.33275H4.52312V6.14772C4.52909 6.10594 4.53506 6.05819 4.55296 6.02238Z",
    fill: "#024649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0487 6.02238H4.54699C4.52909 6.06416 4.52312 6.10594 4.52312 6.14772V6.33275C4.54699 6.32679 4.56489 6.32678 4.58876 6.32678L11.1527 6.32678C11.1228 6.30888 11.1049 6.29694 11.093 6.285C10.7767 6.11191 10.4127 6.02238 10.0487 6.02238Z",
    fill: "#024446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88712 10.3377C5.28095 11.1137 5.81203 11.812 6.45649 12.4029C7.17852 13.0594 8.03779 13.5727 9.01044 13.8891C9.03431 13.8951 9.05221 13.901 9.07608 13.907C8.72998 13.7936 8.38986 13.6563 8.06763 13.4952C7.14272 13.0356 6.33715 12.379 5.69866 11.5911C5.38836 11.2092 5.11984 10.7854 4.88712 10.3377Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5977 14.2174C10.7708 14.2353 10.9438 14.2412 11.1169 14.2412C11.1049 14.2412 11.087 14.2412 11.0751 14.2412C10.914 14.2353 10.7588 14.2293 10.5977 14.2174ZM8.06763 13.5011C8.38986 13.6623 8.72998 13.7996 9.07608 13.913C9.32073 13.9906 9.57136 14.0562 9.82795 14.104C9.20736 13.9786 8.61661 13.7757 8.06763 13.5011ZM4.12929 6.88784C4.08752 8.10545 4.35604 9.28724 4.88712 10.3377C5.11387 10.7854 5.38836 11.2092 5.69866 11.5971C4.86325 10.5586 4.31427 9.28724 4.16509 7.90848C4.14719 7.73539 4.13526 7.56827 4.12929 7.38921C4.12929 7.30565 4.12332 7.22208 4.12332 7.14449C4.12332 7.0669 4.12332 6.99527 4.12929 6.91768V6.88784Z",
    fill: "#024A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0751 14.2412C11.087 14.2412 11.1049 14.2412 11.1169 14.2412C11.1228 14.2412 11.1228 14.2412 11.1288 14.2412C11.1467 14.2412 11.1646 14.2412 11.1825 14.2412C11.1467 14.2412 11.1109 14.2412 11.0751 14.2412Z",
    fill: "#024649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5465 6.49988C11.6121 6.54762 11.6718 6.59537 11.7255 6.65506H11.8628C11.7673 6.60134 11.6539 6.54762 11.5465 6.49988ZM11.1527 6.32678L4.58876 6.32678C4.56489 6.32678 4.54102 6.32679 4.52312 6.33275L10.9975 6.33275C11.0691 6.33275 11.1467 6.34469 11.2123 6.35663C11.1944 6.34469 11.1706 6.33872 11.1527 6.32678Z",
    fill: "#024143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 7.38921C4.13526 7.5623 4.14719 7.73539 4.16509 7.90848C4.15316 7.73539 4.13526 7.5623 4.12929 7.38921Z",
    fill: "#024245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5465 6.49988C11.6121 6.54762 11.6718 6.59537 11.7255 6.65506C11.6718 6.60134 11.6121 6.54762 11.5465 6.49988ZM10.9975 6.33275C11.0691 6.33275 11.1467 6.34469 11.2123 6.35663C11.1467 6.33872 11.0751 6.33275 10.9975 6.33275Z",
    fill: "#02383A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 6.33275H4.17106C4.15316 6.48794 4.14122 6.64312 4.13526 6.79831H4.17106V6.5715H4.22476V6.38647C4.23073 6.37453 4.23073 6.35066 4.23073 6.33275Z",
    fill: "#023638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52312 6.33275H4.23073C4.22476 6.35066 4.22476 6.37453 4.22476 6.39244V6.57747H4.2367C4.28444 6.45213 4.39184 6.35663 4.52312 6.33275Z",
    fill: "#013536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 6.33275C4.39781 6.35663 4.2904 6.45213 4.24267 6.57747H4.52909L4.52909 6.33275Z",
    fill: "#013335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9975 6.33275L4.52909 6.33275L4.52909 6.57747H11.0333H11.0393C11.0453 6.57747 11.0512 6.57747 11.0572 6.57747C11.2004 6.57747 11.3376 6.60731 11.457 6.66103H11.7315C11.6778 6.60134 11.6181 6.54763 11.5525 6.50584C11.4272 6.45213 11.3078 6.40438 11.2183 6.3626C11.1467 6.33872 11.0751 6.33275 10.9975 6.33275Z",
    fill: "#013234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 6.91768C4.12929 6.99527 4.12332 7.0669 4.12332 7.14449C4.12332 7.22805 4.12332 7.31161 4.12929 7.38921H4.13526C4.13526 7.32952 4.12929 7.26983 4.12929 7.21015C4.12929 7.1803 4.12929 7.15046 4.12929 7.12062L4.12929 7.05496V6.91768Z",
    fill: "#023638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70462 11.5971C6.34311 12.385 7.14868 13.0415 8.0736 13.5011C7.14868 13.0415 6.34311 12.3909 5.70462 11.5971Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17106 7.90848C4.32024 9.28127 4.86922 10.5586 5.70462 11.5971C6.34311 12.3909 7.15465 13.0415 8.0736 13.5011C8.62258 13.7757 9.21333 13.9786 9.83391 14.104C9.85778 14.1099 9.88762 14.1159 9.91149 14.1219H9.91745C10.1442 14.1636 10.371 14.1935 10.5977 14.2174C10.7588 14.2293 10.914 14.2412 11.0751 14.2412C10.8961 14.2353 10.723 14.2233 10.55 14.2114C7.21432 13.8891 4.53506 11.2569 4.17106 7.90848Z",
    fill: "#023638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.55 14.2114C10.723 14.2293 10.902 14.2412 11.0751 14.2412C11.1109 14.2412 11.1467 14.2412 11.1825 14.2412C11.1885 14.2412 11.1885 14.2412 11.1944 14.2412C11.2004 14.2412 11.2064 14.2412 11.2123 14.2412C11.2183 14.2412 11.2243 14.2412 11.2362 14.2412C11.0094 14.2412 10.7767 14.2293 10.55 14.2114Z",
    fill: "#013536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13526 7.38921C4.13526 7.5623 4.14719 7.73539 4.17106 7.90848C4.54102 11.2569 7.21432 13.8891 10.55 14.2114C10.2337 14.1815 9.92342 14.1278 9.6191 14.0562C8.74192 13.8533 7.92442 13.4832 7.20835 12.9878C6.36101 12.4029 5.63899 11.6329 5.11387 10.7317C4.55296 9.77667 4.20686 8.68441 4.14719 7.51455C4.14122 7.47277 4.13526 7.43099 4.13526 7.38921Z",
    fill: "#013234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6191 14.0562C9.92342 14.1278 10.2337 14.1815 10.55 14.2114C10.7767 14.2353 11.0035 14.2472 11.2362 14.2472C11.2362 14.2472 11.2362 14.2472 11.2422 14.2472C10.6813 14.2412 10.1382 14.1756 9.6191 14.0562ZM5.10791 10.7257C5.63899 11.627 6.35505 12.3969 7.20239 12.9818C6.35505 12.3969 5.63899 11.621 5.10791 10.7257Z",
    fill: "#013133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 6.57747H4.17703V6.80428V6.667H4.22476C4.22476 6.65506 4.22476 6.64312 4.23073 6.63716V6.57747Z",
    fill: "#013133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24267 6.57747H4.23073L4.23073 6.63119C4.23073 6.61328 4.2367 6.59537 4.24267 6.57747Z",
    fill: "#012F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 6.63119C4.23073 6.64312 4.22476 6.65506 4.22476 6.66103H4.23073V6.63119Z",
    fill: "#012F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 6.57747H4.24267C4.2367 6.59537 4.23073 6.61328 4.23073 6.63119V6.66103H4.46345H4.46942H4.47539H4.52909V6.57747Z",
    fill: "#012E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0512 6.57747C11.0453 6.57747 11.0393 6.57747 11.0333 6.57747H4.52909V6.66103H11.4451H11.457C11.3317 6.60731 11.1944 6.57747 11.0512 6.57747Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13526 6.79831C4.13526 6.81025 4.12929 6.82815 4.12929 6.84009L4.12929 6.88187C4.12929 6.858 4.13526 6.82815 4.13526 6.79831Z",
    fill: "#024245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13526 6.79831C4.13526 6.82815 4.12929 6.858 4.12929 6.88784V6.91768C4.13526 6.8759 4.13526 6.84009 4.13526 6.79831Z",
    fill: "#024245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17106 6.79831H4.13526C4.13526 6.84009 4.12929 6.8759 4.12929 6.91768V7.05496H4.13526V6.86396C4.14719 6.84009 4.15912 6.82218 4.17106 6.80428L4.17106 6.79831Z",
    fill: "#013234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13526 7.05496H4.12929L4.12929 7.12062C4.12929 7.15046 4.12929 7.1803 4.12929 7.21015L4.13526 7.21015C4.13526 7.17433 4.13526 7.13852 4.13526 7.10868V7.05496Z",
    fill: "#012F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20835 12.9818C7.93038 13.4772 8.74192 13.8473 9.6191 14.0502C8.74192 13.8473 7.93038 13.4832 7.20835 12.9818ZM4.14122 7.51455C4.20686 8.68441 4.54699 9.77667 5.10791 10.7317C4.67827 9.99751 4.37394 9.17981 4.22476 8.30241C4.18299 8.03979 4.15913 7.77717 4.14122 7.51455Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 8.29644C4.37991 9.17981 4.68424 9.99751 5.11387 10.7317C5.63899 11.627 6.36101 12.3969 7.20835 12.9878C7.93038 13.4892 8.74789 13.8533 9.6191 14.0562C10.1382 14.1756 10.6872 14.2412 11.2422 14.2412H11.2481C10.0726 14.2412 8.95674 13.9547 7.97812 13.4414C7.75137 13.3221 7.52461 13.1907 7.3098 13.0475C6.04475 12.2059 5.04823 10.9644 4.52312 9.46033C4.39781 9.08431 4.29637 8.69634 4.23073 8.29644Z",
    fill: "#012C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 9.46033C5.0542 10.9644 6.05072 12.2119 7.31576 13.0535C6.40278 12.4447 5.63302 11.6329 5.08404 10.672C4.85729 10.284 4.6723 9.87814 4.52909 9.46033Z",
    fill: "#012C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97812 13.4414C8.95674 13.9547 10.0726 14.2412 11.2481 14.2412C11.4271 14.2412 11.6062 14.2412 11.7792 14.2174H11.7613C11.5942 14.2353 11.4212 14.2353 11.2541 14.2353C11.2541 14.2353 11.2541 14.2353 11.2481 14.2353H11.2422C11.2362 14.2353 11.2302 14.2353 11.2243 14.2353C11.1885 14.2353 11.1527 14.2353 11.1109 14.2353C9.98906 14.2114 8.92093 13.9309 7.97812 13.4414Z",
    fill: "#012B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1049 14.2353C11.1407 14.2353 11.1765 14.2353 11.2183 14.2353C11.2243 14.2353 11.2302 14.2353 11.2362 14.2353C11.1944 14.2353 11.1527 14.2353 11.1049 14.2353Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31576 13.0475C7.53058 13.1907 7.75137 13.3221 7.98409 13.4414C7.91845 13.4056 7.85281 13.3698 7.79314 13.334C7.62606 13.2504 7.46494 13.149 7.31576 13.0475Z",
    fill: "#012B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07807 10.666C5.62705 11.627 6.39682 12.4447 7.3098 13.0475C7.46494 13.149 7.62009 13.2445 7.7812 13.334C7.25609 13.0415 6.77275 12.6834 6.34311 12.2716C5.8538 11.8 5.42417 11.2629 5.07807 10.666Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7553 14.2174H11.7374C11.7255 14.2174 11.7076 14.2174 11.6957 14.2233C11.5465 14.2353 11.3913 14.2353 11.2362 14.2353H11.2422C11.2422 14.2353 11.2422 14.2353 11.2481 14.2353C11.4212 14.2353 11.5942 14.2353 11.7553 14.2174ZM7.78717 13.34C7.85281 13.3758 7.91845 13.4116 7.97812 13.4474C8.92093 13.9368 9.98309 14.2174 11.1049 14.2412C9.91745 14.2114 8.78369 13.8951 7.78717 13.34Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34908 12.2716C6.77872 12.6834 7.26206 13.0415 7.78717 13.334C8.78369 13.8891 9.91745 14.2054 11.1049 14.2293C11.1467 14.2293 11.1944 14.2293 11.2362 14.2293C11.3913 14.2293 11.5465 14.2293 11.6957 14.2174C11.5644 14.2233 11.4271 14.2233 11.2899 14.2233H11.2839C11.272 14.2233 11.266 14.2233 11.2541 14.2233H11.2481C9.35057 14.2293 7.62606 13.4892 6.34908 12.2716Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8508 14.2114C11.8449 14.2114 11.8329 14.2114 11.827 14.2174C11.8329 14.2174 11.8329 14.2174 11.8389 14.2174C11.8389 14.2114 11.8449 14.2114 11.8508 14.2114Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2114C11.8031 14.2174 11.7792 14.2174 11.7613 14.2174H11.7792C11.7971 14.2174 11.8091 14.2114 11.827 14.2114Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2054C11.8508 14.2054 11.8449 14.2054 11.8389 14.2054C11.8329 14.2054 11.827 14.2054 11.821 14.2054V14.2114C11.827 14.2114 11.8389 14.2114 11.8449 14.2054C11.8508 14.2114 11.8568 14.2114 11.8568 14.2054Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2114C11.7971 14.2174 11.7673 14.2174 11.7374 14.2174H11.7553C11.7792 14.2174 11.8031 14.2114 11.827 14.2114Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8389 14.2054C11.8329 14.2054 11.827 14.2054 11.821 14.2054C11.8329 14.2114 11.8389 14.2054 11.8389 14.2054Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8687 6.66103H11.7315C11.7613 6.69087 11.7852 6.72669 11.809 6.7625C11.8449 6.7804 11.8747 6.80428 11.9045 6.82815V6.6849C11.8926 6.67297 11.8807 6.667 11.8687 6.66103Z",
    fill: "#023E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7255 6.66103C11.7553 6.69087 11.7792 6.72669 11.8031 6.7625C11.7852 6.72669 11.7553 6.69087 11.7255 6.66103Z",
    fill: "#013638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7255 6.66103H11.451C11.5763 6.667 11.7016 6.70281 11.8031 6.7625C11.7852 6.72669 11.7553 6.69087 11.7255 6.66103Z",
    fill: "#013032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46942 6.66103C4.46345 6.66103 4.46345 6.66103 4.46942 6.66103Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4451 6.66103H11.457C11.451 6.66103 11.4451 6.66103 11.4451 6.66103Z",
    fill: "#012C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17106 6.81025C4.15912 6.82815 4.14719 6.84606 4.13526 6.86993V7.06093H4.17106V6.81025Z",
    fill: "#013133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17106 7.05496H4.13526V7.10868C4.13526 7.14449 4.13526 7.1803 4.13526 7.21015H4.17106C4.17106 7.16837 4.17106 7.12659 4.17106 7.09077V7.05496Z",
    fill: "#012E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2601 14.2293C11.2541 14.2293 11.2541 14.2293 11.2481 14.2293H11.2541C11.266 14.2293 11.272 14.2293 11.2839 14.2293C11.278 14.2293 11.272 14.2293 11.2601 14.2293Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17703 6.80428C4.17106 6.81025 4.17106 6.80428 4.17703 6.80428Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17703 7.05496L4.17703 7.09077C4.17703 7.13255 4.17703 7.17433 4.17703 7.21015C4.17703 7.17433 4.17703 7.13852 4.17703 7.10868L4.17703 7.05496Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 6.66103H4.17703V6.79831H4.18299C4.19493 6.7804 4.21283 6.76847 4.22476 6.75056V6.69087C4.22476 6.6849 4.22476 6.67297 4.22476 6.66103Z",
    fill: "#012E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 6.66103C4.22476 6.67297 4.22476 6.6849 4.22476 6.69684V6.75653L4.23073 6.75056V6.66103Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46345 6.66103H4.23073V6.75056C4.2904 6.69684 4.37394 6.66103 4.46345 6.66103Z",
    fill: "#012C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17703 6.79831L4.17106 6.80428C4.17703 6.80428 4.17703 6.80428 4.17703 6.79831Z",
    fill: "#012C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.809 6.7625C11.8449 6.81622 11.8807 6.88187 11.9045 6.94156V6.82815C11.8747 6.80428 11.8389 6.7804 11.809 6.7625Z",
    fill: "#02383A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.809 6.7625C11.8449 6.81622 11.8807 6.88187 11.9045 6.94156C11.8807 6.8759 11.8449 6.81622 11.809 6.7625Z",
    fill: "#013234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.457 6.66103C11.6479 6.74459 11.8031 6.88784 11.9045 7.0669V6.94753C11.8807 6.88187 11.8449 6.82218 11.809 6.76847C11.7016 6.70281 11.5823 6.667 11.457 6.66103Z",
    fill: "#012E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 6.75653C4.20686 6.76847 4.19493 6.78637 4.18299 6.80428H4.22476V6.75653Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 6.75056L4.22476 6.75653V6.80428H4.23073V6.75056Z",
    fill: "#012C2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 6.66103H4.47539H4.46345C4.37394 6.66103 4.29637 6.69684 4.23073 6.75056V6.80428H4.52909V6.66103Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4451 6.66103H4.52909L4.52909 6.79831H11.0333C11.0393 6.79831 11.0453 6.79831 11.0512 6.79831C11.3913 6.79831 11.6957 6.9714 11.8747 7.23999C11.8866 7.24596 11.8986 7.24596 11.9105 7.25193V7.0669C11.809 6.88784 11.6479 6.74459 11.463 6.66103C11.451 6.66103 11.4451 6.66103 11.4451 6.66103Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 6.79831H4.18299L4.17703 6.80428L4.17703 7.05496H4.22476V6.79831Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 7.05496H4.17703L4.17703 7.10868C4.17703 7.14449 4.17703 7.1803 4.17703 7.21015H4.22476V7.05496Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 6.79831H4.22476V7.05496H4.23073V6.79831Z",
    fill: "#012A2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 7.05496H4.22476L4.22476 7.21611H4.23073V7.05496Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 6.79831H4.23073V7.05496H4.52909L4.52909 6.79831Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0512 6.79831C11.0453 6.79831 11.0393 6.79831 11.0333 6.79831H4.52909L4.52909 7.05496H11.0035C11.2004 7.05496 11.3794 7.11465 11.5346 7.21612H11.6778C11.7434 7.21612 11.809 7.22805 11.8747 7.24596C11.6897 6.97737 11.3913 6.79831 11.0512 6.79831Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 7.05496H4.23073V7.21611H4.52909V7.05496Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9975 7.05496H4.52909V7.21611L11.5346 7.21612C11.3734 7.11465 11.1944 7.05496 10.9975 7.05496Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7374 14.2174L11.7255 14.2174C11.7136 14.2174 11.7076 14.2174 11.6957 14.2233C11.7076 14.2233 11.7255 14.2174 11.7374 14.2174Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7255 14.2174H11.7016C11.5704 14.2293 11.4271 14.2293 11.2839 14.2293L11.2899 14.2293C11.4272 14.2293 11.5644 14.2293 11.6957 14.2233C11.7076 14.2233 11.7195 14.2174 11.7255 14.2174Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.827 14.2054C11.7971 14.2114 11.7613 14.2174 11.7255 14.2174L11.7374 14.2174C11.7673 14.2174 11.7971 14.2114 11.827 14.2054Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.1995C11.8091 14.2054 11.7553 14.2114 11.7016 14.2174H11.7255C11.7613 14.2114 11.7911 14.2114 11.827 14.2054V14.2114C11.8329 14.2114 11.8389 14.2114 11.8449 14.2114C11.8449 14.2054 11.8508 14.2054 11.8568 14.1995Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7016 14.2174H11.5823C11.4749 14.2233 11.3675 14.2293 11.2601 14.2293C11.266 14.2293 11.278 14.2293 11.2839 14.2293C11.4271 14.2293 11.5704 14.2293 11.7016 14.2174Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.1935C11.7673 14.2054 11.6718 14.2114 11.5823 14.2174H11.7016C11.7553 14.2114 11.8031 14.2054 11.8568 14.1995V14.1935Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2233L11.8568 14.2353H11.8628V14.2233Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2174C11.8628 14.2233 11.8568 14.2233 11.8628 14.2174Z",
    fill: "#023C3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2114C11.8628 14.2174 11.8568 14.2174 11.8628 14.2114C11.8628 14.2174 11.8628 14.2174 11.8628 14.2114Z",
    fill: "#013536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2114C11.8628 14.2174 11.8628 14.2174 11.8628 14.2114Z",
    fill: "#0D4C4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2353V14.2233C11.8628 14.2293 11.8628 14.2293 11.8628 14.2353Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8687 14.2174H11.8628L11.8628 14.2233C11.8628 14.2293 11.8628 14.2353 11.8628 14.2353C11.8628 14.2353 11.8628 14.2353 11.8687 14.2353V14.2174Z",
    fill: "#0B3F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8807 14.2174H11.8687V14.2353C11.8747 14.2353 11.8747 14.2353 11.8807 14.2353V14.2174Z",
    fill: "#0A3D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8687 14.2114H11.8628V14.2174L11.8687 14.2114Z",
    fill: "#0A3C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8807 14.2114C11.8747 14.2114 11.8747 14.2114 11.8687 14.2114V14.2174H11.8807V14.2114Z",
    fill: "#0B3B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43163 15.7752C8.32422 15.8886 8.22277 16.008 8.1273 16.1333C8.21681 16.0199 8.31228 15.9065 8.41372 15.7991C8.41969 15.7871 8.42566 15.7811 8.43163 15.7752Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5798 14.4501C9.76231 14.6949 9.01641 15.1544 8.43163 15.7752C8.42566 15.7811 8.41969 15.7931 8.40776 15.7991C8.98657 15.1783 9.7265 14.7128 10.55 14.4621C10.5619 14.4561 10.5738 14.4501 10.5798 14.4501Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2472C11.7911 14.2472 11.7255 14.2532 11.6599 14.2532C11.7195 14.2472 11.7852 14.2472 11.8449 14.2472C11.8508 14.2472 11.8508 14.2472 11.8568 14.2472Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8449 14.2472C11.7852 14.2472 11.7195 14.2532 11.6599 14.2532C11.6241 14.2532 11.5883 14.2591 11.5584 14.2591C11.6479 14.2591 11.7494 14.2532 11.8449 14.2472Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8449 14.2472C11.7494 14.2472 11.6479 14.2532 11.5525 14.2651C11.5405 14.2651 11.5286 14.2651 11.5167 14.2711C11.63 14.2591 11.7374 14.2532 11.8449 14.2472Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8449 14.2472C11.7374 14.2472 11.63 14.2591 11.5226 14.2651C11.2004 14.295 10.8841 14.3546 10.5798 14.4501C10.5738 14.4501 10.5619 14.4561 10.5559 14.4561C10.9498 14.3367 11.3675 14.2651 11.7911 14.2472C11.7971 14.2472 11.809 14.2472 11.815 14.2472C11.827 14.2472 11.8389 14.2472 11.8449 14.2472Z",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.821 14.2472C11.815 14.2472 11.8031 14.2472 11.7971 14.2472C11.8031 14.2472 11.809 14.2472 11.815 14.2472C11.815 14.2472 11.815 14.2472 11.821 14.2472Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2353L11.8568 14.2472H11.8628V14.2353Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2472C11.8508 14.2472 11.8508 14.2472 11.8449 14.2472C11.8389 14.2472 11.827 14.2472 11.821 14.2472C11.8329 14.2472 11.8449 14.2472 11.8568 14.2472Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2472C11.8449 14.2472 11.8329 14.2472 11.821 14.2472H11.815C11.827 14.2472 11.8389 14.2472 11.8568 14.2472Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2353V14.2472H11.8568C11.8628 14.2472 11.8628 14.2472 11.8687 14.2472C11.8687 14.2472 11.8628 14.2412 11.8628 14.2353Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8687 14.2353C11.8628 14.2412 11.8628 14.2412 11.8687 14.2472L11.8687 14.2353Z",
    fill: "#0A3D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8807 14.2353C11.8747 14.2353 11.8747 14.2353 11.8687 14.2353L11.8687 14.2472C11.8747 14.2472 11.8807 14.2472 11.8807 14.2472V14.2353Z",
    fill: "#0A3C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12929 7.21611C4.12929 7.2758 4.12929 7.33549 4.13526 7.39517C4.13526 7.32952 4.13526 7.2758 4.12929 7.21611Z",
    fill: "#013536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13526 7.21611H4.12929C4.12929 7.2758 4.12929 7.33549 4.13526 7.39517H4.14122C4.14122 7.32952 4.14122 7.2758 4.13526 7.21611Z",
    fill: "#012E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14122 7.38921H4.13526C4.13526 7.43099 4.14122 7.47277 4.14122 7.50858C4.15316 7.7712 4.18299 8.03382 4.23073 8.29047V8.25466C4.23073 8.24273 4.22476 8.23079 4.22476 8.21288C4.18299 7.94429 4.15316 7.66973 4.14122 7.38921Z",
    fill: "#012C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 8.25466V8.29047C4.29637 8.69038 4.39781 9.07834 4.52909 9.45436V9.44243C4.39781 9.0664 4.29637 8.6665 4.23073 8.25466Z",
    fill: "#012B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 9.4484V9.46033C4.67827 9.88411 4.86325 10.29 5.08404 10.666C4.85729 10.284 4.6723 9.87217 4.52909 9.4484Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 8.25466C4.23073 8.24273 4.22476 8.23079 4.22476 8.21288C4.22476 8.23079 4.22476 8.24273 4.23073 8.25466Z",
    fill: "#012B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 8.25466C4.29637 8.6665 4.39781 9.0664 4.52909 9.4484L4.52909 9.44243C4.39185 9.05446 4.29637 8.66053 4.23073 8.25466Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 9.43646L4.52909 9.44243C4.67827 9.87217 4.86325 10.278 5.08404 10.66C5.43013 11.2569 5.8538 11.7941 6.34908 12.2656C5.8359 11.7762 5.39433 11.2092 5.04823 10.5824C4.83938 10.2243 4.66633 9.84233 4.52909 9.43646Z",
    fill: "#012A2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04227 10.5944C5.38836 11.2211 5.82993 11.7881 6.34311 12.2775C7.62009 13.4892 9.3446 14.2353 11.2422 14.2353C8.58677 14.2293 6.26554 12.761 5.04227 10.5944Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17703 7.21611H4.14122C4.14122 7.2758 4.14122 7.33549 4.14719 7.39517H4.18299C4.17703 7.32952 4.17703 7.2758 4.17703 7.21611Z",
    fill: "#012D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17703 7.38921H4.14122C4.15316 7.66973 4.17703 7.94429 4.2188 8.21288V8.16513C4.20089 8.02785 4.18299 7.88461 4.17106 7.74733H4.2009C4.19493 7.6757 4.18896 7.59811 4.18299 7.52649C4.18299 7.47874 4.18299 7.43696 4.17703 7.38921Z",
    fill: "#012B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2009 7.74733H4.17106C4.18299 7.89057 4.20089 8.02785 4.2188 8.16513V7.94429C4.21283 7.87864 4.20686 7.81298 4.2009 7.74733Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 8.1711V8.21885C4.22476 8.23079 4.23073 8.24273 4.23073 8.26063V8.21288C4.22476 8.19498 4.22476 8.18304 4.22476 8.1711Z",
    fill: "#012B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 7.94429V8.16513C4.22476 8.17707 4.23073 8.19498 4.23073 8.20691V7.99801C4.22476 7.9801 4.22476 7.9622 4.22476 7.94429Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 8.20691L4.23073 8.25466C4.29637 8.66053 4.39781 9.06043 4.52909 9.43646L4.52909 9.42452C4.39185 9.03656 4.2904 8.63069 4.23073 8.20691Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 9.42452L4.52909 9.43646C4.66633 9.83636 4.83938 10.2243 5.04823 10.5884C4.83938 10.2243 4.66634 9.83636 4.52909 9.42452Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 7.99801V8.21288C4.29637 8.63069 4.39781 9.04253 4.52909 9.43049V9.33499C4.38588 8.89928 4.28444 8.4576 4.23073 7.99801Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 9.32902L4.52909 9.42452C4.66634 9.83039 4.83938 10.2184 5.04823 10.5884C6.26554 12.755 8.58677 14.2233 11.2541 14.2233C11.2601 14.2233 11.2601 14.2233 11.266 14.2233C8.11536 14.2174 5.454 12.1641 4.52909 9.32902Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17703 7.21611C4.17703 7.2758 4.17703 7.33549 4.18299 7.39517C4.17703 7.32952 4.17703 7.2758 4.17703 7.21611Z",
    fill: "#012A2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17703 7.38921C4.17703 7.43696 4.18299 7.47874 4.18299 7.52649C4.18299 7.47874 4.18299 7.43696 4.17703 7.38921Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2114C11.8628 14.2174 11.8568 14.2174 11.8628 14.2114Z",
    fill: "#012F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.2054C11.8568 14.2054 11.8568 14.2054 11.8628 14.2054L11.8568 14.2114C11.8568 14.2114 11.8568 14.2114 11.8628 14.2114L11.8628 14.2054Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 14.2174H11.8807V14.2353C11.8866 14.2353 11.8926 14.2353 11.8986 14.2353V14.2174Z",
    fill: "#0B3B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 14.1995C11.8866 14.1995 11.8747 14.2054 11.8628 14.2054L11.8628 14.2114H11.8687C11.8747 14.2114 11.8747 14.2114 11.8807 14.2114V14.2174H11.8986V14.2353V14.1995Z",
    fill: "#09393B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41372 15.7991C8.31228 15.9065 8.21681 16.0199 8.1273 16.1333C7.93635 16.378 7.7633 16.6466 7.62009 16.9331H7.62606C7.83491 16.5153 8.10343 16.1333 8.41372 15.7991Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5559 14.4561C9.73247 14.7068 8.99254 15.1723 8.41372 15.7931C8.10343 16.1273 7.83491 16.5093 7.63202 16.9271C7.66783 16.8555 7.70363 16.7899 7.73943 16.7242C7.94828 16.3541 8.19891 16.0199 8.48533 15.7274C8.99851 15.2022 9.62506 14.7904 10.3292 14.5337C10.4008 14.5098 10.4784 14.48 10.5559 14.4561Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75137 16.7242H7.73943C7.70363 16.7899 7.66783 16.8615 7.63202 16.9271L7.64396 16.9271C7.67379 16.8615 7.7096 16.7899 7.75137 16.7242ZM10.3292 14.5337C9.62506 14.7844 8.99851 15.1962 8.48533 15.7274C8.8553 15.3454 9.28493 15.0291 9.75634 14.7904C9.84585 14.7426 9.93536 14.7008 10.0308 14.659C10.1263 14.6173 10.2277 14.5755 10.3292 14.5337Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75137 16.7242C7.7096 16.7899 7.67379 16.8615 7.63799 16.9331H7.64396C7.67976 16.8615 7.71556 16.7899 7.75137 16.7242ZM10.0249 14.659C9.93535 14.7008 9.83988 14.7426 9.75037 14.7904C9.80408 14.7605 9.85778 14.7366 9.91149 14.7128C9.95326 14.6949 9.98906 14.6769 10.0249 14.659Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76927 16.7242H7.75733C7.72153 16.7899 7.67976 16.8615 7.64993 16.9271H7.66783C7.69766 16.8555 7.73347 16.7899 7.76927 16.7242Z",
    fill: "#164E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73943 16.7242C7.94828 16.3541 8.19891 16.0199 8.48533 15.7274C8.19891 16.0259 7.94828 16.3601 7.73943 16.7242Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75634 14.7904C9.28493 15.0291 8.8553 15.3454 8.48533 15.7274C8.19891 16.0259 7.94828 16.3601 7.73943 16.7242H7.75137C8.21681 15.9005 8.909 15.2261 9.75634 14.7904Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91745 14.7128C9.86375 14.7366 9.81004 14.7665 9.75634 14.7904C8.91497 15.2261 8.21681 15.9005 7.75137 16.7242H7.75733C8.13923 16.0497 8.67628 15.4767 9.32074 15.047C9.51169 14.9217 9.7086 14.8083 9.91745 14.7128Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32074 15.047C8.67628 15.4708 8.13923 16.0497 7.75733 16.7242H7.76927C8.15117 16.0438 8.68225 15.4708 9.32074 15.047Z",
    fill: "#164E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.1995C11.8568 14.2054 11.8568 14.2054 11.8568 14.1995C11.8628 14.2054 11.8628 14.1995 11.8568 14.1995Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8628 14.1995C11.8628 14.2054 11.8628 14.2054 11.8628 14.1995Z",
    fill: "#093739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8687 7.23999C11.8807 7.2579 11.8926 7.2758 11.9045 7.29968V7.25193C11.8926 7.24596 11.8807 7.24596 11.8687 7.23999Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7911 14.2532C11.3675 14.2711 10.9498 14.3427 10.5559 14.4621C10.4784 14.4859 10.4008 14.5098 10.3292 14.5397C10.735 14.3904 11.1646 14.3009 11.6121 14.2651C11.6718 14.2591 11.7315 14.2532 11.7911 14.2532Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.815 14.2472C11.809 14.2472 11.8031 14.2472 11.7971 14.2472C11.7374 14.2472 11.6778 14.2532 11.6121 14.2591C11.6718 14.2532 11.7315 14.2532 11.7852 14.2472C11.7971 14.2532 11.8031 14.2532 11.815 14.2472Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6121 14.2591C11.1646 14.295 10.735 14.3845 10.3292 14.5337C10.2277 14.5695 10.1263 14.6113 10.0249 14.659C10.5142 14.4442 11.0512 14.3069 11.6121 14.2591Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 14.2532C11.7255 14.2532 11.6658 14.2591 11.6121 14.2651C11.0512 14.3069 10.5201 14.4442 10.0308 14.665C9.99503 14.6829 9.95922 14.7008 9.91745 14.7187C10.1502 14.6113 10.3948 14.5158 10.6454 14.4442C10.9498 14.3546 11.272 14.295 11.6002 14.2711C11.6599 14.2591 11.7195 14.2532 11.7852 14.2532Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77524 16.7182C7.73347 16.7839 7.69766 16.8555 7.66186 16.9271H7.66783C7.69766 16.8555 7.73943 16.7899 7.77524 16.7182ZM11.5942 14.2651C11.266 14.289 10.9498 14.3487 10.6395 14.4382C10.8543 14.3785 11.0691 14.3308 11.2959 14.3009C11.3973 14.283 11.4928 14.2711 11.5942 14.2651Z",
    fill: "#154B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6454 14.4382C10.3948 14.5098 10.1502 14.5994 9.91745 14.7128C9.7086 14.8142 9.51169 14.9276 9.32074 15.053C9.7265 14.7844 10.1681 14.5755 10.6454 14.4382Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2959 14.3009C11.0751 14.3308 10.8543 14.3785 10.6395 14.4382C10.1621 14.5755 9.72054 14.7844 9.31477 15.047C8.67628 15.4708 8.1452 16.0438 7.7633 16.7182H7.76927C8.31228 15.7632 9.15962 15.0172 10.18 14.6053C10.538 14.4621 10.908 14.3606 11.2959 14.3009Z",
    fill: "#154B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79314 16.7182H7.77524C7.73943 16.7839 7.69766 16.8555 7.66783 16.9212H7.68573C7.71556 16.8555 7.75733 16.7839 7.79314 16.7182Z",
    fill: "#14484C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.186 14.6053C9.16559 15.0172 8.31825 15.7632 7.77524 16.7182H7.79314C8.33018 15.7692 9.17156 15.0231 10.186 14.6053Z",
    fill: "#14484C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18896 7.52649C4.19493 7.59811 4.20089 7.6757 4.20686 7.74733C4.19493 7.6757 4.18896 7.60408 4.18896 7.52649Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2009 7.74733C4.20686 7.81298 4.21283 7.87864 4.2188 7.94429V7.93832C4.21283 7.87864 4.20686 7.81298 4.2009 7.74733Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 7.93832C4.22476 7.9622 4.23073 7.9801 4.23073 7.99801V7.99204C4.22476 7.97414 4.22476 7.95623 4.22476 7.93832Z",
    fill: "#01292A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 7.99204V7.99801C4.2904 8.4576 4.38588 8.90525 4.52909 9.32902L4.52909 9.31709C4.38588 8.89331 4.28444 8.44566 4.23073 7.99204Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 9.31709L4.52909 9.32902C5.45997 12.1641 8.12133 14.2174 11.266 14.2293C11.3734 14.2293 11.4809 14.2233 11.5883 14.2174H11.2959H11.2839C8.13327 14.2174 5.45997 12.1641 4.52909 9.31709Z",
    fill: "#012829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2472C11.8449 14.2472 11.827 14.2472 11.815 14.2472C11.809 14.2472 11.7971 14.2472 11.7911 14.2472C11.8091 14.2532 11.8329 14.2472 11.8568 14.2472Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2472C11.8329 14.2472 11.809 14.2472 11.7852 14.2472C11.7195 14.2532 11.6599 14.2532 11.5942 14.2591C11.6837 14.2591 11.7673 14.2532 11.8568 14.2472Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8568 14.2472C11.7673 14.2472 11.6837 14.2532 11.5942 14.2591C11.4928 14.2711 11.3913 14.283 11.2959 14.295C11.4809 14.277 11.6658 14.2591 11.8568 14.2472Z",
    fill: "#14494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8687 14.2472C11.8687 14.2472 11.8628 14.2472 11.8568 14.2472C11.8628 14.2472 11.8628 14.2472 11.8687 14.2472Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 14.2353C11.8926 14.2353 11.8866 14.2353 11.8807 14.2353V14.2472C11.8747 14.2472 11.8687 14.2472 11.8687 14.2472C11.8807 14.2472 11.8926 14.2472 11.8986 14.2472L11.8986 14.2353Z",
    fill: "#0A393B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8986 14.2472C11.8866 14.2472 11.8747 14.2472 11.8687 14.2472C11.8628 14.2472 11.8628 14.2472 11.8568 14.2472L11.8568 14.2532C11.6658 14.2591 11.4809 14.2711 11.2959 14.3009C10.908 14.3606 10.5321 14.4621 10.18 14.6113C10.7171 14.3905 11.2959 14.2711 11.8986 14.2472Z",
    fill: "#14494D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 7.21611H4.17703C4.17703 7.2758 4.17703 7.33549 4.18299 7.39517H4.22476L4.22476 7.21611Z",
    fill: "#012A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 7.21611H4.22476V7.38921H4.23073V7.21611Z",
    fill: "#01282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6718 7.21611H11.5286C11.6957 7.32355 11.827 7.48471 11.9045 7.66973V7.30564C11.8926 7.28774 11.8807 7.26386 11.8687 7.24596C11.809 7.22208 11.7434 7.21611 11.6718 7.21611Z",
    fill: "#01292B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 7.21611H4.23073V7.38921H4.52909V7.21611Z",
    fill: "#012829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5286 7.21611H4.52909L4.52909 7.39517H11.0035C11.4152 7.40114 11.7673 7.6578 11.9105 8.02188V7.66973C11.827 7.47874 11.6957 7.32355 11.5286 7.21611Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 15.7811C11.6837 16.1273 10.7887 16.4019 10.4306 16.4019L7.78717 16.7182C7.75137 16.7839 7.7096 16.8555 7.67976 16.9212L10.3829 16.6048C10.7887 16.6048 11.9045 16.2407 11.9045 15.8349V15.7811Z",
    fill: "#14474A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 7.38921L4.18299 7.38921C4.18299 7.43696 4.18896 7.47874 4.18896 7.52649C4.19493 7.59811 4.20089 7.6757 4.20686 7.74733H4.22476V7.38921Z",
    fill: "#012829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22476 7.74733H4.20686C4.21283 7.81298 4.2188 7.87267 4.22476 7.93832V7.74733Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 7.38921H4.22476V7.74733H4.23073V7.38921Z",
    fill: "#012729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23073 7.74733H4.22476V7.93832C4.22476 7.95623 4.23073 7.97414 4.23073 7.99204V7.74733Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 7.38921H4.23073V7.74733H4.52909V7.38921Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9975 7.38921L4.52909 7.38921V7.74733L11.0273 7.74733C11.0333 7.74733 11.0393 7.74733 11.0453 7.74733C11.4092 7.74733 11.7315 7.94429 11.9105 8.24273V8.00995C11.7613 7.65183 11.4092 7.39518 10.9975 7.38921Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.52909 7.74733H4.23073V7.98607C4.2904 8.44566 4.38588 8.88734 4.52909 9.31709V7.74733Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0453 7.74733C11.0393 7.74733 11.0333 7.74733 11.0273 7.74733L4.52909 7.74733V9.31709C5.45997 12.1582 8.13327 14.2114 11.2899 14.2174L11.2959 14.2174H11.5883C11.6778 14.2114 11.7732 14.2054 11.8628 14.1935V14.1995C11.8628 14.1995 11.8628 14.1995 11.8687 14.1995C11.8329 13.9368 11.815 13.6742 11.815 13.4056C11.815 13.0356 11.8508 12.6715 11.9105 12.3193V8.24869C11.7315 7.95026 11.4092 7.74733 11.0453 7.74733Z",
    fill: "#012728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 12.3134C11.8389 12.6655 11.809 13.0296 11.809 13.3997C11.809 13.6682 11.827 13.9368 11.8628 14.1935V14.1995C11.8747 14.1995 11.8866 14.1935 11.8986 14.1935V14.2412H11.9045L11.9045 12.3134Z",
    fill: "#093739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 14.2472L11.8986 14.2472V14.2532C11.2959 14.2651 10.7171 14.3905 10.186 14.6053C9.17156 15.0231 8.33018 15.7692 7.79314 16.7182L10.4366 16.4019C10.7946 16.4019 11.6897 16.1273 11.9105 15.7811V14.2472",
    fill: "#14474A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00249 5.99254H10.9975C11.5465 5.99254 11.994 6.44019 11.994 6.98931V17.0047C12 17.5538 11.5525 18.0075 11.0035 18.0075H1.00249C0.447538 18.0075 0 17.5598 0 17.0047V6.99527C0 6.44019 0.447538 5.99254 1.00249 5.99254Z",
    fill: "#03787C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.63053 11.9314C4.38588 11.7762 4.17703 11.5673 4.02188 11.3226C3.88463 11.054 3.81303 10.7555 3.81303 10.4511C3.80109 10.0393 3.93834 9.63939 4.20089 9.32305C4.48135 9.00672 4.83938 8.77394 5.23918 8.6486C5.69269 8.49938 6.17006 8.42775 6.65341 8.42775C7.27996 8.40985 7.91248 8.49341 8.5092 8.69038V10.0035C8.25261 9.84233 7.96618 9.72892 7.66783 9.66327C7.3456 9.58568 7.0174 9.54389 6.68921 9.54389C6.34311 9.53196 5.99105 9.60358 5.68076 9.75877C5.44207 9.8662 5.28095 10.1049 5.28095 10.3676C5.28095 10.5287 5.34063 10.6779 5.454 10.7913C5.58528 10.9227 5.74043 11.0361 5.90154 11.1196C6.09846 11.2092 6.39085 11.3405 6.76678 11.4956L6.88613 11.5434C7.26206 11.6866 7.62606 11.8597 7.97215 12.0686C8.545 12.3969 8.87916 13.0236 8.84336 13.6861C8.86126 14.104 8.72998 14.5158 8.47936 14.856C8.22874 15.1664 7.88861 15.3932 7.50671 15.5066C7.05917 15.6498 6.58777 15.7155 6.12233 15.7155C5.70462 15.7155 5.28095 15.6797 4.86922 15.6081C4.51119 15.5543 4.15912 15.4529 3.82496 15.3156V13.9309C4.14122 14.1517 4.49925 14.3188 4.86922 14.4263C5.23918 14.5397 5.62108 14.6053 6.00895 14.6113C6.36698 14.6352 6.73098 14.5576 7.04724 14.3905C7.26802 14.2651 7.3993 14.0323 7.3993 13.7816C7.3993 13.6026 7.3277 13.4295 7.19642 13.3042C7.04724 13.1549 6.87419 13.0296 6.67727 12.9341C6.44455 12.8207 6.10443 12.6655 5.66285 12.4805C5.29886 12.3313 4.95276 12.1462 4.63053 11.9314Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicrosoftSharepoint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/microsoft-sharepoint.f5312b875a88cf9f1c7f86801cda8a3c.svg";